<template>
    <div id="valve-sizing-tool">
        <div class="mainp showPrint">
            <div class="row" style="_margin-top:50px">
                <div class="mainLeft" style="display:inline;width:45%;_background-color: #aaaaaa">
                    <div><span v-translate>Valve Type</span></div>
                    <div id="pValveType"></div>
                    <br>
                    <div><span v-translate>Pipe Dimension</span></div>
                    <div id="pPipeDimension"></div>
                    <br>
                    <div><span v-translate>Valve Dimension</span></div>
                    <div id="pValveDimension"></div>
                    <br>
                    <div><span v-translate>Units</span></div>
                    <div id="pUnits"></div>
                    <br>
                </div>
                <div class="mainRight" style="display:inline;width:50%; _background-color: #0054ae;">
                    <div style="margin-left:0%;">
                        <img src="../assets/produkt_0.jpg" id="pProductImg" style="width:300px; margin-left:-60px;"/>
                    </div>
                </div>
            </div>
            <br style="clear: both;">
            <h1 style="margin-top:0; text-align: left"><span v-translate>Performance Data</span></h1>
            <div class="row">
                <div class="mainLeft" style="display:inline;width:25%;_background-color: #aaaaaa">
                    <div><span v-translate>Inletpressure (P1)</span></div>
                    <span id="pInletpressure">5</span> <span class="pUnitPressure">bar</span><br><br>
                    <div><span v-translate>min. Flow</span></div>
                    <span id="pMinFlow">500</span> <span class="pUnitFlow">l/h</span><br><br>
                </div>
                <div class="mainRight" style="display:inline;width:50%; _background-color: #0054ae;">
                    <div><span v-translate>Outletpressure (P2)</span></div>
                    <span id="pOutletpressure">4</span> <span class="pUnitPressure">bar</span><br><br>
                    <div><span v-translate>max. Flow</span></div>
                    <span id="pMaxFlow">1000</span> <span class="pUnitFlow">l/h</span><br><br>
                </div>
            </div>
            <div id="pDiagramm" style="width:60%;"></div>

        </div>

        <div class="main hidePrint">
<!--<div style="height: 90px;">-->
<!--          <div class="halfRow">-->
<!--            <div class="myblock">-->
<!--              <div class="myLabel">-->
<!--                <span><translate>Valve Type</translate></span>-->
<!--                <span class="infoI" id="tooltipMaterial" v-tooltip.right="{ ref: 'refTooltipValve' }">&nbsp;</span>-->
<!--              </div>-->
<!--              <div class="row hidePrint">-->
<!--                <div class="selectWrapper">-->
<!--                  <Multiselect id="selectValve" ref="selectValve" @changeSelect="onValveChanged" ></Multiselect>-->
<!--                </div>-->
<!--                <div ref="refTooltipValve" class="tooltip-content">-->
<!--                  <translate>Tooltip Valve</translate>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--</div>-->
<!--          <div class="halfRow"></div>-->
          <br>
            <div class="halfRow">
                <div class="myblock">
                    <div class="myLabel">
                        <span><translate>Valve Type</translate></span>
                        <span class="infoI" id="tooltipMaterial" v-tooltip.right="{ ref: 'refTooltipValve' }">&nbsp;</span>
                    </div>
                    <div class="row hidePrint">
                        <div class="selectWrapper">
                          <Multiselect id="selectValve" ref="selectValve" @changeSelect="onValveChanged"></Multiselect>
                        </div>
                        <div ref="refTooltipValve" class="tooltip-content">
                            <translate>Tooltip Valve</translate>
                        </div>
                    </div>
                </div>

              <div class="myblock">
                <div class="myLabel">
                  <span><translate>Units</translate></span>
                  <span class="infoI" v-tooltip.right="{ ref: 'refTooltipUnits' }">&nbsp;</span>
                </div>
                <div class="row hidePrint">
                  <div class="selectWrapper">
                    <Multiselect id="unit" ref="unit" @changeSelect="onUnit"></Multiselect>

                  </div>
                  <div ref="refTooltipUnits" class="tooltip-content">
                    <translate>Tooltip Units</translate>
                  </div>
                </div>
              </div>

                <div class="myblock">
                    <div class="myLabel">
                        <span><translate>Pipe Dimension</translate></span>
                        <span class="infoI" v-tooltip.right="{ ref: 'refTooltipPipeDimension' }">&nbsp;</span>
                    </div>
                    <div class="row hidePrint">
                        <div class="selectWrapper">
                          <Multiselect id="selectDimension" ref="selectDimension" @changeSelect="onSelectDimension"></Multiselect>

                        </div>
                        <div ref="refTooltipPipeDimension" class="tooltip-content">
                            <translate>Tooltip Pipe Dimension</translate>
                        </div>
                    </div>
                </div>

              <div class="myblock">
                <div class="myLabel">
                  <span style="display: inline-block"><translate>Medienliste</translate></span>
                  <span class="infoI" v-tooltip.right="{ ref: 'refTooltipDensity' }">&nbsp;</span>
                </div>
                <div class="row hidePrint">
                  <div class="selectWrapper">
                    <Multiselect id="selectDensity" ref="selectDensity" @changeSelect="changeDensity"></Multiselect>
                  </div>
                  <div ref="refTooltipDensity" class="tooltip-content">
                    <translate>Tooltip Density</translate>
                  </div>
                </div>
              </div>

              <div class="myblock">
                <div class="myLabel">
                  <span><translate>Density g/cm<sup>3</sup></translate></span>

                </div>
                <div class="row hidePrint">
                  <div class="selectWrapper">
                    <input id="inputDensity"  ref="inputDensity" value="" @input="changeDensityInput"  style="margin:0; border:0; display: inline-block">
                  </div>
                </div>
              </div>


            </div>

            <div class="halfRow">


                <div class="myblock">
                    <div class="myLabel">
                        <span><translate>Inletpressure (P1)</translate> <span class="unit1"></span></span>
                        <span class="infoI" v-tooltip.left="{ ref: 'refTooltipPressure' }">&nbsp;</span>
                    </div>
                  <div ref="refTooltipPressure" class="tooltip-content">
                    <translate>Tooltip Pressure</translate>
                  </div>
                    <div class="row hidePrint">
                        <div class="inputWrapper">
                            <input id="inletPressure" class="inputNumber inputplaceholder">
                            <div class="myerror" id="error_inletPressure"><translate>warning Inletpressure</translate></div>
                        </div>

                    </div>
                </div>

                <div class="myblock">
                    <div class="myLabel">
                        <span><translate>Outletpressure (P2)</translate> <span class="unit1"></span></span>
                        <span class="infoI" v-tooltip.left="{ ref: 'refTooltipPressure' }">&nbsp;</span>
                    </div>
                    <div class="row hidePrint">
                        <div class="inputWrapper">
                            <input id="outletPressure" class="inputNumber inputplaceholder">
                          <div class="myerror" id="error_pressureDrop"><translate>Warning Pressuredrop</translate></div>
                        </div>
                    </div>
                </div>


                <div class="myblock">
                    <div class="myLabel">
                        <span><translate>min. Flow</translate> <span class="unit2"></span></span>
                        <span class="infoI" v-tooltip.right="{ ref: 'refTooltipFlow' }">&nbsp;</span>
                    </div>
                    <div class="row hidePrint">
                        <div class="inputWrapper">
                            <input id="flowQ1" class="inputNumber inputplaceholder">
                        </div>
                        <div ref="refTooltipFlow" class="tooltip-content">
                            <translate>Tooltip Flow</translate>
                        </div>
                    </div>
                </div>

                <div class="myblock">
                    <div class="myLabel">
                        <span><translate>max. Flow</translate> <span class="unit2"></span></span>
                        <span class="infoI" v-tooltip.right="{ ref: 'refTooltipFlow' }">&nbsp;</span>
                    </div>
                    <div class="row hidePrint">
                        <div class="inputWrapper">
                            <input id="flowQ2" class="inputNumber inputplaceholder">
                          <div class="myerror" id="error_maxFlow"><translate>Warning max flow velocity</translate></div>
                        </div>
                    </div>
                </div>

              <div class="myblock" style="margin-top: 80px">
                <div class="myLabel">
                  <span><translate>Valve Dimension</translate></span>
                  <span class="infoI" v-tooltip.right="{ ref: 'refTooltipValveInformation' }">&nbsp;</span>
                </div>
                <div class="row hidePrint">
                  <div class="selectWrapper">
                    <Multiselect id="selectDimension2" ref="selectDimension2" @changeSelect="doCalc" style="border: 3px solid #ff6600"></Multiselect>
                  </div>
                  <div ref="refTooltipValveInformation" class="tooltip-content">
                    <translate>Tooltip Valve Information</translate>
                  </div>
                </div>
              </div>

              <div class="myblock" style="margin-bottom: 20px">
                <button @click="doCalc" id="bBerechnen"><translate>Berechnen</translate></button>
              </div>

            </div>

            <div class="halfRow" style="margin-right: 0; ">
                <div class="imageWrapper">
                    <span class="helper"></span>
                    <img src="img/produkt_0.jpg" id="productImg" style="width:100%">
                </div>
            </div>
            <br class="clearfix">
            <div class="arrow hidePrint" style="margin-left: -6px;">
                <span id="doPrint" class="bImage" v-on:click="preparePrint"><translate>Print</translate></span>
            </div>
            <div class="arrow hidePrint" style="margin-left: -6px;">
                <span id="sendEmail" class="bImage" v-on:click="sendMail"><translate>E-Mail</translate></span>
            </div>


            <br class="clearfix">
        </div>
            <div id="myDiagram">

                    <h1><span v-translate>Flow Characteristics</span> <span id="headline">Ball valvetype 546 d16 DN10 (3/8'')</span> <span class="myerror" id="error_cavitation"><translate>warning Cavitation</translate></span><br><span class="myerror" style="display: block"><translate>Please use the Chemical resistance tool to assess the optimal material for the selected valve, ensuring compatibility with the chosen medium.</translate></span></h1>
                <div id="outerImage">
                    <div class="flowValue" data-percent="10">1234</div>
                    <div class="flowValue" data-percent="9">1234</div>
                    <div class="flowValue" data-percent="8">1234</div>
                    <div class="flowValue" data-percent="7">1234</div>
                    <div class="flowValue" data-percent="6">1234</div>
                    <div class="flowValue" data-percent="5">1234</div>
                    <div class="flowValue" data-percent="4">1234</div>
                    <div class="flowValue" data-percent="3">1234</div>
                    <div class="flowValue" data-percent="2">1234</div>
                    <div class="flowValue" data-percent="1">1234</div>
                    <div class="flowValue" data-percent="0">0</div>
                    <div class="pValue" id="firstP">0%</div>
                    <div class="pValue">20%</div>
                    <div class="pValue">40%</div>
                    <div class="pValue">60%</div>
                    <div class="pValue">80%</div>
                    <div class="pValue" id="lastP">100%</div>
                    <div class="dFlow"><span v-translate>Flow</span></div>
                    <div class="oAngle"><span v-translate><translate>Opening angle in %</translate></span></div>
                    <img src="../assets/diagram_0.svg" width="100%" id="imgDiagram"/>
                    <div id="openingLeft" class="openingRed" title="Vibration"></div>
                    <div id="openingRight" class="openingRed" title="Kavitation"></div>
                    <img src="../assets/locator.png" id="locatorLeft" class="locator"/>
                    <img src="../assets/locator.png" id="locatorRight" class="locator"/>
                </div>

            </div>

            <br class="clearfix"/>
        <div class="showPrint" style="margin: 16px; text-align: left">
            <strong>Disclaimer:</strong><br><span v-translate style="font-size:12px;">In case of any queries we recommend to contact GF (info.ps@georgfischer.com). GF will be happy to share with you its extensive practical experience, gained over decades in the field of polymer valves and automation. The technical data are not binding. They neither constitute expressly warranted characteristics nor guaranteed properties nor a guaranteed durability. They are subject to modification. Our General Terms of Sale apply.</span>
        </div>


    </div>
</template>

<script>
/* eslint-disable */
    import $ from 'jquery';
    import { useGettext } from "@jshmrtn/vue3-gettext";
    import Multiselect from "@/components/multi_select";
    import classList from "@/assets/classList.min.js"

    import "../../src/assets/diagram_1.svg";
    import "../../src/assets/diagram_1_0.svg";
    import "../../src/assets/diagram_1_1.svg";
    import "../../src/assets/diagram_1_2.svg";
    import "../../src/assets/diagram_1_3.svg";
    import "../../src/assets/diagram_1_4.svg";
    import "../../src/assets/diagram_1_5.svg";
    import "../../src/assets/diagram_2.svg";
    import "../../src/assets/diagram_3.svg";
    import "../../src/assets/diagram_4.svg";
    import "../../src/assets/diagram_5.svg";
    import "../../src/assets/produkt_1.jpg";
    import "../../src/assets/produkt_2.jpg";
    import "../../src/assets/produkt_3.jpg";
    import "../../src/assets/produkt_4.jpg";
    import "../../src/assets/produkt_5.jpg";
let $gettext;
    var tFlow;
    var min = 35, max = 80;
    // eslint-disable-next-line no-unused-vars
    var diagramPercentValues = [];
    var unitPressureMetric;
    var unitPressureImperial;
    var unitFlowMetric;
    var unitFlowImperial;
    var unitPleaseSelect = true;
    var firstUnit = true;
    var unitPressure, unitFlow;
    var wordingLeftLocator;
    var wordingRightLocator;
    var tooltipValveArr;
    var mailSubject;
    var mailBody1;
    var mailBody2;
    export default {
        name: "ControlValveSizing",
      components: {Multiselect},
        props: ['myvm'],
      setup: function () {
        $gettext = useGettext().$gettext;
        window.$gettext = useGettext();
        const language = useGettext();
        return {
          language,
        };
      },
        created: function () {
            var that = this;
            // that.init();

            // that.doCalc();
            setTimeout(function () {
                that.init();
                that.doCalc();
            }, 100);
        },
        methods: {
            togglePrint: function () {
                if ($("#plus").hasClass("printminus"))
                {
                    $("#plus").removeClass("printminus");
                } else
                {
                    $("#plus").addClass("printminus");
                }
                $('#printDiv').toggle();
            },
            getTypeID: function (type) {
                switch (type)
                {
                    case "Ball Valve Type 546":
                    case "Kugelhahn Typ 546":
                        return "Ball Valve Type 546";
                    // break;
                    case "Ball Valve Type 546 linear":
                    case "Linearkugelhahn Typ 546":
                        return "Ball Valve Type 546 linear";
                    // break;
                    case "Diaphragm Valve Type 514 - 517":
                    case "Membranventil Typ 514 - 517":
                        return "Diaphragm Valve Type 514 - 517";
                    // break;
                    case "Diaphragm Valve Type 317 - 025":
                    case "Membranventil Typ 317 - 025":
                        return "Diaphragm Valve Type 317 - 025";
                    // break;
                    case "Butterfly Valve Type 567 - 568":
                    case "Absperrklappe 567 - 568":
                        return "Butterfly Valve Type 567 - 568";
                    // break;
                  case "Butterfly Valve Type 565":
                  case "Absperrklappe 565":
                    return "Butterfly Valve Type 565";
                    // break;
                }
            },
            preparePrint: function () {
                var assetsDir =process.env.NODE_ENV === 'production'
                    ? '/content/dam/gfps/com/website-tools/valve-dimensioning-tool-vue3/'
                    : '';
                $("#pProjectname").text($("#projectname").val());
                $("#pValveTag").text($("#valvetag").val());
                $("#pValveType").text(this.$refs.selectValve.val());
                $("#pPipeDimension").text(this.$refs.selectDimension.val());
                $("#pValveDimension").text(this.$refs.selectDimension2.val());
                $("#pInletpressure").text($("#inletPressure").val());
                $("#pOutletpressure").text($("#outletPressure").val());
                $("#pMinFlow").text($("#flowQ1").val());
                $("#pMaxFlow").text($("#flowQ2").val());
                $("#pUnits").text(unitPressure + " / " + unitFlow);
                $(".pUnitPressure").text(unitPressure);
                $(".pUnitFlow").text(unitFlow);
                $("#pProductImg").attr("src", assetsDir+"img/produkt_" + this.$refs.selectValve.index() + ".jpg");
                $("#pDiagramm").empty();
                setTimeout('window.print()', 800);
            },
            sendMail: function () {
                location.href = "mailto:?to=&subject=" + mailSubject + "&body=" + mailBody1 +  top.location.protocol + '//' + top.location.host + top.location.pathname + "?valve=" + this.$refs.selectValve.index() + "%26dimension=" + this.$refs.selectDimension.index() + "%26dimension2=" + this.$refs.selectDimension2.index() + "%26p1=" + $("#inletPressure").val() + "%26p2=" + $("#outletPressure").val() + "%26q1=" + $("#flowQ1").val() + "%26q2=" + $("#flowQ2").val() + "%26units=" + this.$refs.unit.val() + "%26lang=" + window.myvm.$language.current + mailBody2;
            },
          onSelectDimension: function () {
              var that = this;
            this.$refs.selectDimension2.setSelected( this.$refs.selectDimension.val());
            if( that.$refs.selectValve.val() == -1 || that.$refs.selectDimension.val() == -1 || that.$refs.selectDimension2.val() == -1 || that.$refs.unit.val() == -1){
              $("#myDiagram").hide();
              $(".imageWrapper").hide();
              return;
            } else{
              $(".imageWrapper").show();
              $("#myDiagram").show();
            }
            this.doCalc();
          },
          onUnit: function () {
              var that = this;

            if( that.$refs.selectValve.val() == -1 || that.$refs.selectDimension.val() == -1 || that.$refs.selectDimension2.val() == -1 || that.$refs.unit.val() == -1 ){
              $("#myDiagram").hide();
              $(".imageWrapper").hide();
              unitPleaseSelect = true;
              return;
            } else{
              $(".imageWrapper").show();
              $("#myDiagram").show();
              unitPleaseSelect = false;
            }



            if (this.$refs.unit.val() == "bar / l/h")
            {
              // PSI => bar
              if (!firstUnit)
              {
              unitPressure = unitPressureMetric;
              unitFlow = unitFlowMetric;
              } else {
                unitPressure = unitPressureMetric;
                unitFlow = unitFlowMetric;
                firstUnit = false;
              }
            } else if (this.$refs.unit.val() == "PSI / gpm")
            {
              firstUnit = false;
              // bar => PSI
              unitPressure = unitPressureImperial;
              unitFlow = unitFlowImperial;
            }
            $(".unit1").text($gettext("bar"));
            if (that.$refs.unit.val() == "bar / l/h")
            {
              $(".unit2").text($gettext("l/h"));
              unitPressure = $gettext("bar")
              unitFlow = $gettext("l/h");
            } else if (that.$refs.unit.val() == "bar / l/s")
            {
              $(".unit2").text($gettext("l/s"));
              unitPressure = $gettext("bar")
              unitFlow = $gettext("l/s");
            } else if (that.$refs.unit.val() == "bar / l/min")
            {
              $(".unit2").text($gettext("l/min"));
              unitPressure = $gettext("bar")
              unitFlow = $gettext("l/min");
            } else if (that.$refs.unit.val() == "bar / m3/h")
            {
              $(".unit2").text($gettext("m3/h"));
              unitPressure = $gettext("bar")
              unitFlow = $gettext("m3/h");
            }else if (that.$refs.unit.val() == "PSI / gpm")
            {
              $(".unit1").text($gettext("PSI"));
              $(".unit2").text($gettext("gpm"));
              unitPressure = $gettext("PSI")
              unitFlow = $gettext("gpm");
            }
            this.doCalc();
          },
          init: function () {
                var that = this;


                that.$refs.selectValve.setOptions([
                    {label:$gettext("Please select"), value:"-1"},
                    {label:$gettext("Ball Valve Type 546"), value:"Ball Valve Type 546"},
                    {label:$gettext("Ball Valve Type 546 linear"), value:"Ball Valve Type 546 linear"},
                  {label:$gettext("Diaphragm Valve Type 514 - 517"), value:"Diaphragm Valve Type 514 - 517"},
                  {label:$gettext("Diaphragm Valve Type 317 - 025"), value:"Diaphragm Valve Type 317 - 025"},
                  {label:$gettext("Butterfly Valve Type 567 - 568"), value:"Butterfly Valve Type 567 - 568"},
                  {label:$gettext("Butterfly Valve Type 565"), value:"Butterfly Valve Type 565"},
                ]);

              that.$refs.selectDimension.setOptions([
                {label:$gettext("Please select"), value:"-1"},
                {label:$gettext("d16 DN10 (3/8'')"), value:"d16 DN10 (3/8'')"},
                {label:$gettext("d20 DN15 (1/2'')"), value:"d20 DN15 (1/2'')"},
                {label:$gettext("d25 DN20 (3/4'')"), value:"d25 DN20 (3/4'')"},
                {label:$gettext("d32 DN25 (1'')"), value:"d32 DN25 (1'')"},
                {label:$gettext("d40 DN32 (1 1/4'')"), value:"d40 DN32 (1 1/4'')"},
                {label:$gettext("d50 DN40 (1 1/2)"), value:"d50 DN40 (1 1/2)"},
                {label:$gettext("d63 DN50 (2'')"), value:"d63 DN50 (2'')"},
                {label:$gettext("d75 DN65 (2 1/2'')"), value:"d75 DN65 (2 1/2'')"},
                {label:$gettext("d90 DN80 (3'')"), value:"d90 DN80 (3'')"},
                {label:$gettext("d110 DN100 (4'')"), value:"d110 DN100 (4'')"},
                {label:$gettext("d140 DN125 (5'')"), value:"d140 DN125 (5'')"},
                {label:$gettext("d160 DN150 (6'')"), value:"d160 DN150 (6'')"},
                {label:$gettext("d225 DN200 (8'')"), value:"d225 DN200 (8'')"},
                {label:$gettext("d280 DN250 (10'')"), value:"d280 DN250 (10'')"},
                {label:$gettext("d315 DN300 (12'')"), value:"d315 DN300 (12'')"},
                {label:$gettext("d355 DN350 (14'')"), value:"d355 DN350 (14'')"},
                {label:$gettext("d400 DN400 (16'')"), value:"d400 DN400 (16'')"},
                {label:$gettext("d450 DN450 (18'')"), value:"d450 DN450 (18'')"},
                {label:$gettext("d500 DN500 (20'')"), value:"d500 DN500 (20'')"},
                {label:$gettext("d630 DN600 (24'')"), value:"d630 DN600 (24'')"},
              ]);

              that.$refs.selectDimension2.setOptions([
                {label:$gettext("Please select"), value:"-1"},
                {label:$gettext("d16 DN10 (3/8'')"), value:"d16 DN10 (3/8'')"},
                {label:$gettext("d20 DN15 (1/2'')"), value:"d20 DN15 (1/2'')"},
                {label:$gettext("d25 DN20 (3/4'')"), value:"d25 DN20 (3/4'')"},
                {label:$gettext("d32 DN25 (1'')"), value:"d32 DN25 (1'')"},
                {label:$gettext("d40 DN32 (1 1/4'')"), value:"d40 DN32 (1 1/4'')"},
                {label:$gettext("d50 DN40 (1 1/2)"), value:"d50 DN40 (1 1/2)"},
                {label:$gettext("d63 DN50 (2'')"), value:"d63 DN50 (2'')"},
                {label:$gettext("d75 DN65 (2 1/2'')"), value:"d75 DN65 (2 1/2'')"},
                {label:$gettext("d90 DN80 (3'')"), value:"d90 DN80 (3'')"},
                {label:$gettext("d110 DN100 (4'')"), value:"d110 DN100 (4'')"},
                {label:$gettext("d140 DN125 (5'')"), value:"d140 DN125 (5'')"},
                {label:$gettext("d160 DN150 (6'')"), value:"d160 DN150 (6'')"},
                {label:$gettext("d225 DN200 (8'')"), value:"d225 DN200 (8'')"},
                {label:$gettext("d280 DN250 (10'')"), value:"d280 DN250 (10'')"},
                {label:$gettext("d315 DN300 (12'')"), value:"d315 DN300 (12'')"},
                {label:$gettext("d355 DN350 (14'')"), value:"d355 DN350 (14'')"},
                {label:$gettext("d400 DN400 (16'')"), value:"d400 DN400 (16'')"},
                {label:$gettext("d450 DN450 (18'')"), value:"d450 DN450 (18'')"},
                {label:$gettext("d500 DN500 (20'')"), value:"d500 DN500 (20'')"},
                {label:$gettext("d630 DN600 (24'')"), value:"d630 DN600 (24'')"},
              ]);

            that.$refs.selectDensity.setOptions([
              {label:$gettext("Please select"), value:"-1"},
              {label:$gettext("Wasser"), value:"Wasser"},
              {label:$gettext("Ameisensäure"), value:"Ameisensäure"},
              {label:$gettext("Ammoniumhydroxid < 25 %"), value:"Ammoniumhydroxid < 25 %"},
              {label:$gettext("Chromsäure ≤ 20 %"), value:"Chromsäure ≤ 20 %"},
              {label:$gettext("Citronensäure ≤ 50 %"), value:"Citronensäure ≤ 50 %"},
              {label:$gettext("Eisenchloride ≤ 25 %"), value:"Eisenchloride ≤ 25 %"},
              {label:$gettext("Eisenchloride ≤ 40 %"), value:"Eisenchloride ≤ 40 %"},
              {label:$gettext("Essigsäure"), value:"Essigsäure"},
              {label:$gettext("Flusssäure"), value:"Flusssäure"},
              {label:$gettext("Natriumhypochlorit"), value:"Natriumhypochlorit"},
              {label:$gettext("Natronlauge ≤ 25 %"), value:"Natronlauge ≤ 25 %"},
              {label:$gettext("Natronlauge ≤ 50 %"), value:"Natronlauge ≤ 50 %"},
              {label:$gettext("Kalilauge ≤ 25 %"), value:"Kalilauge ≤ 25 %"},
              {label:$gettext("Kalilauge ≤ 50 %"), value:"Kalilauge ≤ 50 %"},
              {label:$gettext("Peressigsäure"), value:"Peressigsäure"},
              {label:$gettext("Phosphorsäure ≤ 45 %"), value:"Phosphorsäure ≤ 45 %"},
              {label:$gettext("Phosphorsäure ≤ 85 %"), value:"Phosphorsäure ≤ 85 %"},
              {label:$gettext("Salzsäure"), value:"Salzsäure"},
              {label:$gettext("Salpetersäure ≤ 35 %"), value:"Salpetersäure ≤ 35 %"},
              {label:$gettext("Salpetersäure ≤ 50 %"), value:"Salpetersäure ≤ 50 %"},
              {label:$gettext("Salpetersäure ≤ 70 %"), value:"Salpetersäure ≤ 70 %"},
              {label:$gettext("Schwefelsäure ≤ 30 %"), value:"Schwefelsäure ≤ 30 %"},
              {label:$gettext("Schwefelsäure ≤ 50 %"), value:"Schwefelsäure ≤ 50 %"},
              {label:$gettext("Schwefelsäure ≤ 70 %"), value:"Schwefelsäure ≤ 70 %"},
              {label:$gettext("Schwefelsäure > 90 %"), value:"Schwefelsäure > 90 %"},
              {label:$gettext("Wasserstoffperoxid ≤ 50 %"), value:"Wasserstoffperoxid ≤ 50 %"},
              {label:$gettext("Wasserstoffperoxid > 50 %"), value:"Wasserstoffperoxid > 50 %"},
              {label:$gettext("eigener Wert"), value:"eigener Wert"},
            ]);
              that.$refs.unit.setOptions([
                {label:$gettext("Please select"), value:"-1"},
                {label:$gettext("bar / l/h"), value:"bar / l/h"},
                {label:$gettext("bar / l/s"), value:"bar / l/s"},
                {label:$gettext("bar / l/min"), value:"bar / l/min"},
                {label:$gettext("bar / m3/h"), value:"bar / m3/h"},
                {label:$gettext("PSI / gpm"), value:"PSI / gpm"},
              ]);
              $(".inputplaceholder").attr("placeholder", $gettext("Bitte hier einen Wert eintragen"));
              // return;
                $("#selectValve").change(function () {
                    that.onValveChanged();
                });
                $("#inletPressure").change(function () {
                    if ($("#inletPressure").val() < 0)
                    {
                        $("#inletPressure").val(0);
                    }

                    // that.doCalc();
                });
                $("#outletPressure").change(function () {
                    if ($("#outletPressure").val() < 0)
                    {
                        $("#outletPressure").val(0);
                    }
                    // that.doCalc();
                });
                $("#flowQ1").change(function () {
                    if ($("#flowQ1").val() < 0)
                    {
                        $("#flowQ1").val(0);
                    }
                    // that.doCalc();
                });
                $("#flowQ2").change(function () {
                    if ($("#flowQ2").val() < 0)
                    {
                        $("#flowQ2").val(0);
                    }
                    // that.doCalc();
                });


                tFlow = $gettext("Flow");
                min = 35, max = 80;
                // eslint-disable-next-line no-unused-vars
                diagramPercentValues = [];
                unitPressureMetric = $gettext("bar");
                unitPressureImperial = $gettext("PSI");
                unitFlowMetric = $gettext("l/h");
                unitFlowImperial = $gettext("gpm");
                unitPressure, unitFlow;
                wordingLeftLocator = $gettext("Opening angle: @val@% / Flow: ");
                wordingRightLocator = $gettext("Opening angle: @val@% / Flow: ");
                tooltipValveArr = [$gettext("Tooltip Valve 0"), $gettext("Tooltip Valve 1"), $gettext("Tooltip Valve 2"), $gettext("Tooltip Valve 3"), $gettext("Tooltip Valve 4")];
                mailSubject = $gettext("Georg Fischer Piping Systems: Control Valve Sizing Tool");
                mailBody1 = $gettext("I thought you might find this information interesting") + '%0D%0A';
                mailBody2 = "%0D%0A%0D%0A" + $gettext("Disclaimer: %0D%0AThe technical data are not binding. They neither constitute expressly warranted characteristics nor guaranteed properties nor a guaranteed durability. They are subject to modification. Our General Terms of Sale apply.");


                var tcounter = 0;
                $(".flowValue").each(function () {
                    $(this).css("top", tcounter * 7.7 + 2.9 + "%");
                    tcounter++;
                });
                tcounter = 0;
                $(".pValue").each(function () {
                    $(this).css("left", tcounter * 16.2 + 5.4 + "%");
                    tcounter++;
                });
                $("#firstP").css("left", "5%");
                $("#lastP").css("left", "86%");
                if (this.getUrlParameter("valve") != "" && typeof this.getUrlParameter("valve") != "undefined")
                {
                    this.$refs.selectValve.setSelectedIndex(parseInt(this.getUrlParameter("valve"))+1);
                    this.onValveChanged();
                  this.$refs.selectDimension.setSelectedIndex(parseInt(this.getUrlParameter("dimension"))+1);
                  this.$refs.selectDimension2.setSelectedIndex(parseInt(this.getUrlParameter("dimension2"))+1);
                    $("#inletPressure").val(this.getUrlParameter("p1"));
                    $("#outletPressure").val(this.getUrlParameter("p2"));
                    $("#flowQ1").val(this.getUrlParameter("q1"));
                    $("#flowQ2").val(this.getUrlParameter("q2"));

                } else
                {
                    this.onValveChanged();
                }

                if (this.getUrlParameter("dimension2") != "" && typeof this.getUrlParameter("dimension2") != "undefined")
                {
                  this.$refs.selectDimension2.setSelectedIndex(parseInt(this.getUrlParameter("dimension2"))+1);
                }
            if (this.getUrlParameter("units") != "" && typeof this.getUrlParameter("units") != "undefined")
            {
              this.$refs.unit.setSelectedIndex(parseInt(this.getUrlParameter("units")));
            }
                $("#unit").change(function () {
               // ERROR ERROR :D
                    if ($("#unit").val() == "1")
                    {
                        unitPressure = unitPressureMetric;
                        unitFlow = unitFlowMetric;
                    } else
                    {
                        unitPressure = unitPressureImperial;
                        unitFlow = unitFlowImperial;
                    }
                    $("#labelInletPressure, #labelOutletPressure").text(unitPressure);
                    $("#labelFlowQ1, #labelFlowQ2").text(unitFlow);
                    that.doCalc();
                });
                if (that.$refs.unit.val() == "bar / l/h")
                {
                    unitPressure = unitPressureMetric;
                    unitFlow = unitFlowMetric;
                } else if (that.$refs.unit.val() == "PSI / gpm")
                {
                    unitPressure = unitPressureImperial;
                    unitFlow = unitFlowImperial;
                }
                $("#labelInletPressure, #labelOutletPressure").text(unitPressure);
                $("#labelFlowQ1, #labelFlowQ2").text(unitFlow);
            setTimeout(function () {
              that.onValveChanged();
            }, 1000);
            },
          changeDensity: function () {
              let val;
              switch(this.$refs.selectDensity.val()){
                case "eigener Wert":
                  val = "";
                  break;
                case "Wasser":
                  val = 1;
                  break;
                case "Ameisensäure":
                case "Ammoniumhydroxid < 25 %":
                case "Chromsäure ≤ 20 %":
                case "Citronensäure ≤ 50 %":
                case "Eisenchloride ≤ 25 %":
                case "Essigsäure":
                case "Flusssäure":
                case "Natriumhypochlorit":
                case "Natronlauge ≤ 25 %":
                case "Kalilauge ≤ 25 %":
                case "Peressigsäure":
                case "Phosphorsäure ≤ 45 %":
                case "Salzsäure":
                case "Salpetersäure ≤ 35 %":
                case "Schwefelsäure ≤ 30 %":
                case "Wasserstoffperoxid ≤ 50 %":
                  val = 1.1;
                  break;
                case "Salpetersäure ≤ 50 %":
                case "Wasserstoffperoxid > 50 %":
                  val = 1.3;
                  break;
                case "Eisenchloride ≤ 40 %":
                case "Salpetersäure ≤ 70 %":
                case "Schwefelsäure ≤ 50 %":
                  val = 1.4;
                  break;
                case "Natronlauge ≤ 50 %":
                case "Kalilauge ≤ 50 %":
                  val = 1.5;
                  break;
                case "Schwefelsäure ≤ 70 %":
                  val = 1.6;
                  break;
                case "Phosphorsäure ≤ 85 %":
                  val = 1.7;
                  break;
                case "Schwefelsäure > 90 %":
                  val = 1.8;
                  break;
              }
            $("#inputDensity").val(val);
            this.doCalc();
          },
          changeDensityInput: function () {
            this.doCalc();
          },
            onValveChanged: function () {
              var that = this;
                var newValues = [];

              that.$refs.selectDensity.setOptions([
                {label:$gettext("Please select"), value:"-1"},
                {label:$gettext("Wasser"), value:"Wasser"},
                {label:$gettext("Ameisensäure"), value:"Ameisensäure"},
                {label:$gettext("Ammoniumhydroxid < 25 %"), value:"Ammoniumhydroxid < 25 %"},
                {label:$gettext("Chromsäure ≤ 20 %"), value:"Chromsäure ≤ 20 %"},
                {label:$gettext("Citronensäure ≤ 50 %"), value:"Citronensäure ≤ 50 %"},
                {label:$gettext("Eisenchloride ≤ 25 %"), value:"Eisenchloride ≤ 25 %"},
                {label:$gettext("Eisenchloride ≤ 40 %"), value:"Eisenchloride ≤ 40 %"},
                {label:$gettext("Essigsäure"), value:"Essigsäure"},
                {label:$gettext("Flusssäure"), value:"Flusssäure"},
                {label:$gettext("Natriumhypochlorit"), value:"Natriumhypochlorit"},
                {label:$gettext("Natronlauge ≤ 25 %"), value:"Natronlauge ≤ 25 %"},
                {label:$gettext("Natronlauge ≤ 50 %"), value:"Natronlauge ≤ 50 %"},
                {label:$gettext("Kalilauge ≤ 25 %"), value:"Kalilauge ≤ 25 %"},
                {label:$gettext("Kalilauge ≤ 50 %"), value:"Kalilauge ≤ 50 %"},
                {label:$gettext("Peressigsäure"), value:"Peressigsäure"},
                {label:$gettext("Phosphorsäure ≤ 45 %"), value:"Phosphorsäure ≤ 45 %"},
                {label:$gettext("Phosphorsäure ≤ 85 %"), value:"Phosphorsäure ≤ 85 %"},
                {label:$gettext("Salzsäure"), value:"Salzsäure"},
                {label:$gettext("Salpetersäure ≤ 35 %"), value:"Salpetersäure ≤ 35 %"},
                {label:$gettext("Salpetersäure ≤ 50 %"), value:"Salpetersäure ≤ 50 %"},
                {label:$gettext("Salpetersäure ≤ 70 %"), value:"Salpetersäure ≤ 70 %"},
                {label:$gettext("Schwefelsäure ≤ 30 %"), value:"Schwefelsäure ≤ 30 %"},
                {label:$gettext("Schwefelsäure ≤ 50 %"), value:"Schwefelsäure ≤ 50 %"},
                {label:$gettext("Schwefelsäure ≤ 70 %"), value:"Schwefelsäure ≤ 70 %"},
                {label:$gettext("Schwefelsäure > 90 %"), value:"Schwefelsäure > 90 %"},
                {label:$gettext("Wasserstoffperoxid ≤ 50 %"), value:"Wasserstoffperoxid ≤ 50 %"},
                {label:$gettext("Wasserstoffperoxid > 50 %"), value:"Wasserstoffperoxid > 50 %"},
                {label:$gettext("eigener Wert"), value:"eigener Wert"},
              ]);

                switch (this.getTypeID(that.$refs.selectValve.val()))
                {
                    case "Ball Valve Type 546":
                        newValues = ["d16 DN10 (3/8'')", "d20 DN15 (1/2'')", "d25 DN20 (3/4'')", "d32 DN25 (1'')", "d40 DN32 (1 1/4'')", "d50 DN40 (1 1/2'')", "d63 DN50 (2'')", "d75 DN65 (2 1/2'')", "d90 DN80 (3'')", "d110 DN100 (4'')"];
                        min = 20;
                        max = 80;
                        break;
                    case "Ball Valve Type 546 linear":
                        newValues = ["d20 DN15 (1/2'')", "d25 DN20 (3/4'')", "d32 DN25 (1'')", "d40 DN32 (1 1/4'')", "d50 DN40 (1 1/2'')", "d63 DN50 (2'')"];
                        min = 40;
                        max = 90;
                        break;
                    case "Diaphragm Valve Type 514 - 517":
                        newValues = ["d20 DN15 (1/2'')", "d25 DN20 (3/4'')", "d32 DN25 (1'')", "d40 DN32 (1 1/4'')", "d50 DN40 (1 1/2'')", "d63 DN50 (2'')"];
                        min = 20;
                        max = 70;
                        break;
                    case "Diaphragm Valve Type 317 - 025":
                        newValues = ["d75 DN65 (2 1/2'')", "d90 DN80 (3'')", "d110 DN100 (4'')", "d160 DN150 (6'')"];
                        min = 20;
                        max = 60;
                        break;
                    case "Butterfly Valve Type 567 - 568":
                        newValues = ["d63 DN50 (2'')", "d75 DN65 (2 1/2'')", "d90 DN80 (3'')", "d110 DN100 (4'')", "d140 DN125 (5'')", "d160 DN150 (6'')", "d225 DN200 (8'')", "d280 DN250 (10'')", "d315 DN300 (12'')", "d355 DN350 (14'')", "d400 DN400 (16'')", "d450 DN450 (18'')", "d500 DN500 (20'')", "d630 DN600 (24'')"];
                        min = 40;
                        max = 80;
                        break;
                  case "Butterfly Valve Type 565":
                    newValues = ["d63 DN50 (2'')", "d75 DN65 (2 1/2'')", "d90 DN80 (3'')", "d110 DN100 (4'')", "d140 DN125 (5'')", "d160 DN150 (6'')", "d225 DN200 (8'')", "d280 DN250 (10'')", "d315 DN300 (12'')"];
                    min = 40;
                    max = 80;

                    that.$refs.selectDensity.setOptions([
                      {label:$gettext("Please select"), value:"-1"},
                      {label:$gettext("Wasser"), value:"Wasser"},
                      {label:$gettext("Ameisensäure"), value:"Ameisensäure", $isDisabled: true},
                      {label:$gettext("Ammoniumhydroxid < 25 %"), value:"Ammoniumhydroxid < 25 %", $isDisabled: true},
                      {label:$gettext("Chromsäure ≤ 20 %"), value:"Chromsäure ≤ 20 %", $isDisabled: true},
                      {label:$gettext("Citronensäure ≤ 50 %"), value:"Citronensäure ≤ 50 %", $isDisabled: true},
                      {label:$gettext("Eisenchloride ≤ 25 %"), value:"Eisenchloride ≤ 25 %", $isDisabled: true},
                      {label:$gettext("Eisenchloride ≤ 40 %"), value:"Eisenchloride ≤ 40 %", $isDisabled: true},
                      {label:$gettext("Essigsäure"), value:"Essigsäure", $isDisabled: true},
                      {label:$gettext("Flusssäure"), value:"Flusssäure", $isDisabled: true},
                      {label:$gettext("Natriumhypochlorit"), value:"Natriumhypochlorit", $isDisabled: true},
                      {label:$gettext("Natronlauge ≤ 25 %"), value:"Natronlauge ≤ 25 %", $isDisabled: true},
                      {label:$gettext("Natronlauge ≤ 50 %"), value:"Natronlauge ≤ 50 %", $isDisabled: true},
                      {label:$gettext("Kalilauge ≤ 25 %"), value:"Kalilauge ≤ 25 %", $isDisabled: true},
                      {label:$gettext("Kalilauge ≤ 50 %"), value:"Kalilauge ≤ 50 %", $isDisabled: true},
                      {label:$gettext("Peressigsäure"), value:"Peressigsäure", $isDisabled: true},
                      {label:$gettext("Phosphorsäure ≤ 45 %"), value:"Phosphorsäure ≤ 45 %", $isDisabled: true},
                      {label:$gettext("Phosphorsäure ≤ 85 %"), value:"Phosphorsäure ≤ 85 %", $isDisabled: true},
                      {label:$gettext("Salzsäure"), value:"Salzsäure", $isDisabled: true},
                      {label:$gettext("Salpetersäure ≤ 35 %"), value:"Salpetersäure ≤ 35 %", $isDisabled: true},
                      {label:$gettext("Salpetersäure ≤ 50 %"), value:"Salpetersäure ≤ 50 %", $isDisabled: true},
                      {label:$gettext("Salpetersäure ≤ 70 %"), value:"Salpetersäure ≤ 70 %", $isDisabled: true},
                      {label:$gettext("Schwefelsäure ≤ 30 %"), value:"Schwefelsäure ≤ 30 %", $isDisabled: true},
                      {label:$gettext("Schwefelsäure ≤ 50 %"), value:"Schwefelsäure ≤ 50 %", $isDisabled: true},
                      {label:$gettext("Schwefelsäure ≤ 70 %"), value:"Schwefelsäure ≤ 70 %", $isDisabled: true},
                      {label:$gettext("Schwefelsäure > 90 %"), value:"Schwefelsäure > 90 %", $isDisabled: true},
                      {label:$gettext("Wasserstoffperoxid ≤ 50 %"), value:"Wasserstoffperoxid ≤ 50 %", $isDisabled: true},
                      {label:$gettext("Wasserstoffperoxid > 50 %"), value:"Wasserstoffperoxid > 50 %", $isDisabled: true},
                      {label:$gettext("eigener Wert"), value:"eigener Wert", $isDisabled: true},
                    ]);
                    break;
                }
                var selectDimension = [ {label:$gettext("Please select"), value:"-1"}];
                $.each(newValues, function (i, item) {
                  selectDimension.push({label:item,value:item});

                });
              if (that.$refs.selectValve.val() != -1)
              {
                that.$refs.selectDimension.setOptions(selectDimension);
                that.$refs.selectDimension2.setOptions(selectDimension);
              }

              tooltipValveArr = [$gettext("Tooltip Valve 0"), $gettext("Tooltip Valve 1"), $gettext("Tooltip Valve 2"), $gettext("Tooltip Valve 3"), $gettext("Tooltip Valve 4")];
                $("#tooltipValve").prop("title", tooltipValveArr[this.$refs.selectValve.index()]);
                var assetsDir =process.env.NODE_ENV === 'production'
                    ? '/content/dam/gfps/com/website-tools/valve-dimensioning-tool-vue3/'
                    // ? '../../../../content/dam/gfps/com/website-tools/valve-dimensioning-tool-vue3/'
                    : '';
                $("#productImg").prop("src",assetsDir+ "img/produkt_" + this.$refs.selectValve.index() + ".jpg");
                $("#pProductImg").prop("src",assetsDir +"img/produkt_" + this.$refs.selectValve.index() + ".jpg");
              if( that.$refs.selectValve.val() == -1 || that.$refs.selectDimension.val() == -1 || that.$refs.selectDimension2.val() == -1 || that.$refs.unit.val() == -1){
                $("#myDiagram").hide();
                $(".imageWrapper").hide();
                return;
              } else{
                $(".imageWrapper").show();
                $("#myDiagram").show();
              }
                this.doCalc();
            },
          getMaxDurchfluss: function (aDurchfluss) {
              console.log("aDurchfluss",aDurchfluss);
            let max = 0;
            for (const aDurchflussKey in aDurchfluss) {
              if(aDurchfluss[aDurchflussKey] > max) max = aDurchfluss[aDurchflussKey];
            }
            return max;
          },
            doCalc: function () {
              var that = this;
              // console.clear();
               if($("#inletPressure").val() == "" || $("#outletPressure").val() == "" || $("#flowQ1").val() == "" || $("#flowQ2").val() == ""
                 || that.$refs.selectValve.val() == -1 || that.$refs.selectDimension.val() == -1 || that.$refs.selectDimension.val() == "" || that.$refs.selectDimension2.val() == -1 || that.$refs.unit.val() == -1){
                $("#myDiagram").hide();
                $(".imageWrapper").hide();
                 return;
               } else{
                 $(".imageWrapper").show();
                 $("#myDiagram").show();
               }

                $("#pDiagramm").empty();
                var assetsDir =process.env.NODE_ENV === 'production'
                    ? '/content/dam/gfps/com/website-tools/valve-dimensioning-tool-vue3/'
                    : '';
              if(typeof that.$refs.selectValve.index() == "undefined") return;
                if (that.$refs.selectValve.val() != "Ball Valve Type 546 linear")
                {
                    $("#imgDiagram").prop("src", assetsDir +"img/diagram_" + that.$refs.selectValve.index() + ".svg");
                } else
                {
                    $("#imgDiagram").prop("src",assetsDir + "img/diagram_" + that.$refs.selectValve.index() + "_" + that.$refs.selectDimension2.index() + ".svg");
                }
                var aDurchfluss = {};


                switch (this.getTypeID(that.$refs.selectValve.val()))
                {
                    case "Ball Valve Type 546":
                        diagramPercentValues = [0, 1.3, 3, 6, 10, 15, 22, 33, 50, 75, 100];
                        aDurchfluss["d16 DN10 (3/8'')"] = 70;
                        aDurchfluss["d20 DN15 (1/2'')"] = 185;
                        aDurchfluss["d25 DN20 (3/4'')"] = 350;
                        aDurchfluss["d32 DN25 (1'')"] = 700;
                        aDurchfluss["d40 DN32 (1 1/4'')"] = 1000;
                        aDurchfluss["d50 DN40 (1 1/2'')"] = 1600;
                        aDurchfluss["d63 DN50 (2'')"] = 3100;
                        aDurchfluss["d75 DN65 (2 1/2'')"] = 5000;
                        aDurchfluss["d90 DN80 (3'')"] = 7000;
                        aDurchfluss["d110 DN100 (4'')"] = 11000;
                        break;
                    case "Ball Valve Type 546 linear":
                        switch (that.$refs.selectDimension2.val())
                        {
                            case "d20 DN15 (1/2'')":
                                diagramPercentValues = [0, 0, 0, 0, 7, 23, 38, 54, 69, 85, 100];
                                break;
                            case "d25 DN20 (3/4'')":
                                diagramPercentValues = [0, 0, 4, 16, 28, 40, 52, 64, 76, 88, 100];
                                break;
                            case "d32 DN25 (1'')":
                                diagramPercentValues = [0, 0, 4, 16, 28, 40, 52, 64, 76, 88, 100];
                                break;
                            case "d40 DN32 (1 1/4'')":
                                diagramPercentValues = [0, 0, 5, 17, 29, 41, 52, 64, 76, 88, 100];
                                break;
                            case "d50 DN40 (1 1/2'')":
                                diagramPercentValues = [0, 0, 10, 22, 33, 44, 55, 66, 78, 89, 100];
                                break;
                            case "d63 DN50 (2'')":
                                diagramPercentValues = [0, 5, 15, 26, 36, 47, 58, 68, 79, 89, 100];
                                break;
                        }
                        aDurchfluss["d20 DN15 (1/2'')"] = 90;
                        aDurchfluss["d25 DN20 (3/4'')"] = 166;
                        aDurchfluss["d32 DN25 (1'')"] = 235;
                        aDurchfluss["d40 DN32 (1 1/4'')"] = 417;
                        aDurchfluss["d50 DN40 (1 1/2'')"] = 626;
                        aDurchfluss["d63 DN50 (2'')"] = 781;
                        break;
                    case "Diaphragm Valve Type 514 - 517":
                        diagramPercentValues = [0, 5, 12, 24, 36, 48, 61, 80, 91, 98, 100];
                        aDurchfluss["d20 DN15 (1/2'')"] = 125;
                        aDurchfluss["d25 DN20 (3/4'')"] = 271;
                        aDurchfluss["d32 DN25 (1'')"] = 481;
                        aDurchfluss["d40 DN32 (1 1/4'')"] = 759;
                        aDurchfluss["d50 DN40 (1 1/2'')"] = 1263;
                        aDurchfluss["d63 DN50 (2'')"] = 1728;
                        break;
                    case "Diaphragm Valve Type 317 - 025":
                        diagramPercentValues = [0, 6, 24, 49, 73, 86, 93, 96, 98, 99, 100];
                        aDurchfluss["d75 DN65 (2 1/2'')"] = 992;
                        aDurchfluss["d90 DN80 (3'')"] = 1700;
                        aDurchfluss["d110 DN100 (4'')"] = 2700;
                        aDurchfluss["d160 DN150 (6'')"] = 6033;
                        break;
                    case "Butterfly Valve Type 567 - 568":
                        diagramPercentValues = [0, 0, 1.3, 5, 12, 24, 39, 56, 74, 90, 100];
                        aDurchfluss["d63 DN50 (2'')"] = 740;
                        aDurchfluss["d75 DN65 (2 1/2'')"] = 1500;
                        aDurchfluss["d90 DN80 (3'')"] = 2400;
                        aDurchfluss["d110 DN100 (4'')"] = 3800;
                        aDurchfluss["d140 DN125 (5'')"] = 8600;
                        aDurchfluss["d160 DN150 (6'')"] = 11400;
                        aDurchfluss["d225 DN200 (8'')"] = 19900;
                        aDurchfluss["d280 DN250 (10'')"] = 34000;
                        aDurchfluss["d315 DN300 (12'')"] = 50000;
                        aDurchfluss["d355 DN350 (14'')"] = 90000;
                        aDurchfluss["d400 DN400 (16'')"] = 115000;
                        aDurchfluss["d450 DN450 (18'')"] = 155000;
                        aDurchfluss["d500 DN500 (20'')"] = 204000;
                        aDurchfluss["d630 DN600 (24'')"] = 265000;
                        break;
                  case "Butterfly Valve Type 565":
                    diagramPercentValues = [0, 1.1, 2.5, 5, 8.9, 15.5, 20.1, 26.5, 42.2, 65.2, 79.6, 90.3, 98.1, 100];
                    aDurchfluss["d63 DN50 (2'')"] = 1445;
                    aDurchfluss["d75 DN65 (2 1/2'')"] = 2533;
                    aDurchfluss["d90 DN80 (3'')"] = 4017;
                    aDurchfluss["d110 DN100 (4'')"] = 5850;
                    aDurchfluss["d140 DN125 (5'')"] = 11900;
                    aDurchfluss["d160 DN150 (6'')"] = 18050;
                    aDurchfluss["d225 DN200 (8'')"] = 43667;
                    aDurchfluss["d280 DN250 (10'')"] = 62333;
                    aDurchfluss["d315 DN300 (12'')"] = 94500;
                    break;
                }
              $("#error_inletPressure").hide();
              // if (parseInt($("#inletPressure").val()) <= parseInt($("#outletPressure").val())) //edit 20240730
              if ($("#inletPressure").val() <= $("#outletPressure").val())
              {
                // $("#inletPressure").val(parseInt($("#outletPressure").val()) + 1);//edit 20240730
                $("#inletPressure").val(Math.round(($("#outletPressure").val() / 0.85-0.01)*100)/100);
                $("#error_inletPressure").show();
              }
                // var A_3 = $("#inletPressure").val();////edit 20240730
                var A_3 = parseFloat($("#inletPressure").val().replace(",","."));//edit 20240730
                // var B_3 = $("#outletPressure").val();////edit 20240730
                var B_3 = parseFloat($("#outletPressure").val().replace(",","."));//edit 20240730
                if (that.$refs.unit.val() == "PSI / gpm")
                {
                  A_3 *= 0.0689476;
                  B_3 *= 0.0689476;
                }
                var C_3 = A_3 - B_3;

                var E_3 = aDurchfluss[that.$refs.selectDimension2.val()];
                var F_3 = E_3 * Math.sqrt(C_3 * $("#inputDensity").val());
                var G_3 = parseFloat($("#flowQ1").val().replace(",","."));//parseInt($("#flowQ1").val());
                var I_3 = parseFloat($("#flowQ2").val().replace(",","."));//parseInt($("#flowQ2").val());
                $(".dFlow").text(tFlow);

                // console.log("E3", E_3);
                // return;
                // original: l/h - input:m3/h
                if (that.$refs.unit.val() == "bar / l/h")
                {
                    G_3 *= 0.001;
                    I_3 *= 0.001;
                    $(".flowValue").each(function () {
                      $(this).text(Math.round($(this).data("percent") * F_3 / 10 * 60) + " l/h");
                      // $(this).text(Math.round($(this).data("percent") * F_3 / 10) + " l/h");
                    });
                } else if (that.$refs.unit.val() == "bar / l/s")
                {
                  G_3 *= 3.6;
                  I_3 *= 3.6;
                  $(".flowValue").each(function () {
                    $(this).text(Math.round($(this).data("percent") * F_3 / 10 /3600) + " l/s");
                  });
                } else if (that.$refs.unit.val() == "bar / l/min")
                {
                  G_3 *= 0.06;
                  I_3 *= 0.06;
                  $(".flowValue").each(function () {
                    $(this).text(Math.round($(this).data("percent") * F_3 / 10) + " l/min");
                  });
                } else if (that.$refs.unit.val() == "bar / m3/h")
                {
                  $(".flowValue").each(function () {
                    $(this).text(Math.round($(this).data("percent") * F_3 / 10 * 0.06) + " m3/h");
                  });
                }else if (that.$refs.unit.val() == "PSI / gpm")
                {
                    G_3 *= 0.227124707052;
                    I_3 *= 0.227124707052;
                  $(".flowValue").each(function () {
                    $(this).text(Math.round($(this).data("percent") * F_3 / 10000 * 60) + " gpm");
                  });
                }

                var H_3 = G_3 * 1000 / 60;

                var J_3 = I_3 * 1000 / 60;

                var a15 = H_3;
                var f15 = J_3;
                var c15, d15, c16, d16;
                var h15, i15, h16, i16;


                switch (this.getTypeID(that.$refs.selectValve.val()))
                {
                    case "Ball Valve Type 546":
                        if (a15 < F_3 * 0.013)
                        {
                            c15 = 0;
                            d15 = 0;
                            c16 = F_3 * 0.013;
                            d16 = 10;
                        } else if (a15 < F_3 * 0.03)
                        {
                            c15 = F_3 * 0.013;
                            d15 = 10;
                            c16 = F_3 * 0.03;
                            d16 = 20;
                        } else if (a15 < F_3 * 0.06)
                        {
                            c15 = F_3 * 0.03;
                            d15 = 20;
                            c16 = F_3 * 0.06;
                            d16 = 30;
                        } else if (a15 < F_3 * 0.1)
                        {
                            c15 = F_3 * 0.06;
                            d15 = 30;
                            c16 = F_3 * 0.1;
                            d16 = 40;
                        } else if (a15 < F_3 * 0.15)
                        {
                            c15 = F_3 * 0.1;
                            d15 = 40;
                            c16 = F_3 * 0.15;
                            d16 = 50;
                        } else if (a15 < F_3 * 0.22)
                        {
                            c15 = F_3 * 0.15;
                            d15 = 50;
                            c16 = F_3 * 0.22;
                            d16 = 60;
                        } else if (a15 < F_3 * 0.33)
                        {
                            c15 = F_3 * 0.22;
                            d15 = 60;
                            c16 = F_3 * 0.33;
                            d16 = 70;
                        } else if (a15 < F_3 * 0.5)
                        {
                            c15 = F_3 * 0.33;
                            d15 = 70;
                            c16 = F_3 * 0.5;
                            d16 = 80;
                        } else if (a15 < F_3 * 0.75)
                        {
                            c15 = F_3 * 0.5;
                            d15 = 80;
                            c16 = F_3 * 0.75;
                            d16 = 90;
                        } else if (a15 < F_3)
                        {
                            c15 = F_3 * 0.75;
                            d15 = 90;
                            c16 = F_3;
                            d16 = 100;
                        } else
                        {
                            c15 = null;
                            d15 = null;
                            c16 = null;
                            d16 = null;
                        }


                        if (f15 < F_3 * 0.013)
                        {
                            h15 = 0;
                            i15 = 0;
                            h16 = F_3 * 0.013;
                            i16 = 10;
                        } else if (f15 < F_3 * 0.03)
                        {
                            h15 = F_3 * 0.013;
                            i15 = 10;
                            h16 = F_3 * 0.03;
                            i16 = 20;
                        } else if (f15 < F_3 * 0.06)
                        {
                            h15 = F_3 * 0.03;
                            i15 = 20;
                            h16 = F_3 * 0.06;
                            i16 = 30;
                        } else if (f15 < F_3 * 0.1)
                        {
                            h15 = F_3 * 0.06;
                            i15 = 30;
                            h16 = F_3 * 0.1;
                            i16 = 40;
                        } else if (f15 < F_3 * 0.15)
                        {
                            h15 = F_3 * 0.1;
                            i15 = 40;
                            h16 = F_3 * 0.15;
                            i16 = 50;
                        } else if (f15 < F_3 * 0.22)
                        {
                            h15 = F_3 * 0.15;
                            i15 = 50;
                            h16 = F_3 * 0.22;
                            i16 = 60;
                        } else if (f15 < F_3 * 0.33)
                        {
                            h15 = F_3 * 0.22;
                            i15 = 60;
                            h16 = F_3 * 0.33;
                            i16 = 70;
                        } else if (f15 < F_3 * 0.5)
                        {
                            h15 = F_3 * 0.33;
                            i15 = 70;
                            h16 = F_3 * 0.5;
                            i16 = 80;
                        } else if (f15 < F_3 * 0.75)
                        {
                            h15 = F_3 * 0.5;
                            i15 = 80;
                            h16 = F_3 * 0.75;
                            i16 = 90;
                        } else if (f15 < F_3)
                        {
                            h15 = F_3 * 0.75;
                            i15 = 90;
                            h16 = F_3;
                            i16 = 100;
                        } else
                        {
                            h15 = null;
                            i15 = null;
                            h16 = null;
                            i16 = null;
                        }
                        break;
                    case "Ball Valve Type 546 linear":
                        min = 20;
                        max = 90;
                        switch (that.$refs.selectDimension2.val())
                        {
                            case "d20 DN15 (1/2'')":
                                min = 40;
                                max = 90;
                                if (a15 < F_3 * 0.07)
                                {
                                    c15 = 0;
                                    d15 = 30;
                                    c16 = F_3 * 0.07;
                                    d16 = 40;
                                } else if (a15 < F_3 * 0.2285)
                                {
                                    c15 = F_3 * 0.07;
                                    d15 = 40;
                                    c16 = F_3 * 0.2285;
                                    d16 = 50;
                                } else if (a15 < F_3 * 0.38)
                                {
                                    c15 = F_3 * 0.2285;
                                    d15 = 50;
                                    c16 = F_3 * 0.38;
                                    d16 = 60;
                                } else if (a15 < F_3 * 0.5355)
                                {
                                    c15 = F_3 * 0.38;
                                    d15 = 60;
                                    c16 = F_3 * 0.5355;
                                    d16 = 70;
                                } else if (a15 < F_3 * 0.69)
                                {
                                    c15 = F_3 * 0.5355;
                                    d15 = 70;
                                    c16 = F_3 * 0.69;
                                    d16 = 80;
                                } else if (a15 < F_3 * 0.8452)
                                {
                                    c15 = F_3 * 0.69;
                                    d15 = 80;
                                    c16 = F_3 * 0.8452;
                                    d16 = 90;
                                } else if (a15 < F_3)
                                {
                                    c15 = F_3 * 0.8452;
                                    d15 = 90;
                                    c16 = F_3;
                                    d16 = 100;
                                } else
                                {
                                    c15 = null;
                                    d15 = null;
                                    c16 = null;
                                    d16 = null;
                                }


                                if (f15 < F_3 * 0.07)
                                {
                                    h15 = 0;
                                    i15 = 30;
                                    h16 = F_3 * 0.07;
                                    i16 = 40;
                                } else if (f15 < F_3 * 0.2258)
                                {
                                    h15 = F_3 * 0.07;
                                    i15 = 40;
                                    h16 = F_3 * 0.2258;
                                    i16 = 50;
                                } else if (f15 < F_3 * 0.38)
                                {
                                    h15 = F_3 * 0.2258;
                                    i15 = 50;
                                    h16 = F_3 * 0.38;
                                    i16 = 60;
                                } else if (f15 < F_3 * 0.5355)
                                {
                                    h15 = F_3 * 0.38;
                                    i15 = 60;
                                    h16 = F_3 * 0.5355;
                                    i16 = 70;
                                } else if (f15 < F_3 * 0.69)
                                {
                                    h15 = F_3 * 0.5355;
                                    i15 = 70;
                                    h16 = F_3 * 0.69;
                                    i16 = 80;
                                } else if (f15 < F_3 * 0.8452)
                                {
                                    h15 = F_3 * 0.69;
                                    i15 = 80;
                                    h16 = F_3 * 0.8452;
                                    i16 = 90;
                                } else if (f15 < F_3)
                                {
                                    h15 = F_3 * 0.8452;
                                    i15 = 90;
                                    h16 = F_3 * 1;
                                    i16 = 100;
                                } else
                                {
                                    h15 = null;
                                    i15 = null;
                                    h16 = null;
                                    i16 = null;
                                }
                                break;
                            case"d25 DN20 (3/4'')":
                                if (a15 < F_3 * 0.037)
                                {
                                    c15 = 0;
                                    d15 = 10;
                                    c16 = F_3 * 0.037;
                                    d16 = 20;
                                } else if (a15 < F_3 * 0.1574)
                                {
                                    c15 = F_3 * 0.037;
                                    d15 = 20;
                                    c16 = F_3 * 0.1574;
                                    d16 = 30;
                                } else if (a15 < F_3 * 0.2778)
                                {
                                    c15 = F_3 * 0.1574;
                                    d15 = 30;
                                    c16 = F_3 * 0.2778;
                                    d16 = 40;
                                } else if (a15 < F_3 * 0.3981)
                                {
                                    c15 = F_3 * 0.2778;
                                    d15 = 40;
                                    c16 = F_3 * 0.3981;
                                    d16 = 50;
                                } else if (a15 < F_3 * 0.5185)
                                {
                                    c15 = F_3 * 0.3981;
                                    d15 = 50;
                                    c16 = F_3 * 0.5185;
                                    d16 = 60;
                                } else if (a15 < F_3 * 0.6389)
                                {
                                    c15 = F_3 * 0.5185;
                                    d15 = 60;
                                    c16 = F_3 * 0.6389;
                                    d16 = 70;
                                } else if (a15 < F_3 * 0.76)
                                {
                                    c15 = F_3 * 0.6389;
                                    d15 = 70;
                                    c16 = F_3 * 0.76;
                                    d16 = 80;
                                } else if (a15 < F_3 * 0.88)
                                {
                                    c15 = F_3 * 0.76;
                                    d15 = 80;
                                    c16 = F_3 * 0.88;
                                    d16 = 90;
                                } else if (a15 < F_3)
                                {
                                    c15 = F_3 * 0.88;
                                    d15 = 90;
                                    c16 = F_3;
                                    d16 = 100;
                                } else
                                {
                                    c15 = null;
                                    d15 = null;
                                    c16 = null;
                                    d16 = null;
                                }


                                if (f15 < F_3 * 0.04)
                                {
                                    h15 = 0;
                                    i15 = 10;
                                    h16 = F_3 * 0.04;
                                    i16 = 20;
                                } else if (f15 < F_3 * 0.16)
                                {
                                    h15 = F_3 * 0.04;
                                    i15 = 20;
                                    h16 = F_3 * 0.16;
                                    i16 = 30;
                                } else if (f15 < F_3 * 0.28)
                                {
                                    h15 = F_3 * 0.16;
                                    i15 = 30;
                                    h16 = F_3 * 0.28;
                                    i16 = 40;
                                } else if (f15 < F_3 * 0.40)
                                {
                                    h15 = F_3 * 0.28;
                                    i15 = 40;
                                    h16 = F_3 * 0.40;
                                    i16 = 50;
                                } else if (f15 < F_3 * 0.52)
                                {
                                    h15 = F_3 * 0.4;
                                    i15 = 50;
                                    h16 = F_3 * 0.52;
                                    i16 = 60;
                                } else if (f15 < F_3 * 0.64)
                                {
                                    h15 = F_3 * 0.52;
                                    i15 = 60;
                                    h16 = F_3 * 0.64;
                                    i16 = 70;
                                } else if (f15 < F_3 * 0.76)
                                {
                                    h15 = F_3 * 0.64;
                                    i15 = 70;
                                    h16 = F_3 * 0.76;
                                    i16 = 80;
                                } else if (f15 < F_3 * 0.88)
                                {
                                    h15 = F_3 * 0.76;
                                    i15 = 80;
                                    h16 = F_3 * 0.88;
                                    i16 = 90;
                                } else if (f15 < F_3)
                                {
                                    h15 = F_3 * 0.88;
                                    i15 = 90;
                                    h16 = F_3;
                                    i16 = 100;
                                } else
                                {
                                    h15 = null;
                                    i15 = null;
                                    h16 = null;
                                    i16 = null;
                                }
                                break;
                            case"d32 DN25 (1'')":
                                if (a15 < F_3 * 0.04)
                                {
                                    c15 = 0;
                                    d15 = 10;
                                    c16 = F_3 * 0.04;
                                    d16 = 20;
                                } else if (a15 < F_3 * 0.16)
                                {
                                    c15 = F_3 * 0.04;
                                    d15 = 20;
                                    c16 = F_3 * 0.16;
                                    d16 = 30;
                                } else if (a15 < F_3 * 0.28)
                                {
                                    c15 = F_3 * 0.16;
                                    d15 = 30;
                                    c16 = F_3 * 0.28;
                                    d16 = 40;
                                } else if (a15 < F_3 * 0.4)
                                {
                                    c15 = F_3 * 0.28;
                                    d15 = 40;
                                    c16 = F_3 * 0.4;
                                    d16 = 50;
                                } else if (a15 < F_3 * 0.52)
                                {
                                    c15 = F_3 * 0.4;
                                    d15 = 50;
                                    c16 = F_3 * 0.52;
                                    d16 = 60;
                                } else if (a15 < F_3 * 0.64)
                                {
                                    c15 = F_3 * 0.52;
                                    d15 = 60;
                                    c16 = F_3 * 0.64;
                                    d16 = 70;
                                } else if (a15 < F_3 * 0.76)
                                {
                                    c15 = F_3 * 0.64;
                                    d15 = 70;
                                    c16 = F_3 * 0.76;
                                    d16 = 80;
                                } else if (a15 < F_3 * 0.88)
                                {
                                    c15 = F_3 * 0.76;
                                    d15 = 80;
                                    c16 = F_3 * 0.88;
                                    d16 = 90;
                                } else if (a15 < F_3)
                                {
                                    c15 = F_3 * 0.88;
                                    d15 = 90;
                                    c16 = F_3;
                                    d16 = 100;
                                } else
                                {
                                    c15 = null;
                                    d15 = null;
                                    c16 = null;
                                    d16 = null;
                                }


                                if (f15 < F_3 * 0.04)
                                {
                                    h15 = 0;
                                    i15 = 10;
                                    h16 = F_3 * 0.04;
                                    i16 = 20;
                                } else if (f15 < F_3 * 0.16)
                                {
                                    h15 = F_3 * 0.04;
                                    i15 = 20;
                                    h16 = F_3 * 0.16;
                                    i16 = 30;
                                } else if (f15 < F_3 * 0.28)
                                {
                                    h15 = F_3 * 0.16;
                                    i15 = 30;
                                    h16 = F_3 * 0.28;
                                    i16 = 40;
                                } else if (f15 < F_3 * 0.40)
                                {
                                    h15 = F_3 * 0.28;
                                    i15 = 40;
                                    h16 = F_3 * 0.40;
                                    i16 = 50;
                                } else if (f15 < F_3 * 0.52)
                                {
                                    h15 = F_3 * 0.4;
                                    i15 = 50;
                                    h16 = F_3 * 0.52;
                                    i16 = 60;
                                } else if (f15 < F_3 * 0.64)
                                {
                                    h15 = F_3 * 0.52;
                                    i15 = 60;
                                    h16 = F_3 * 0.64;
                                    i16 = 70;
                                } else if (f15 < F_3 * 0.76)
                                {
                                    h15 = F_3 * 0.64;
                                    i15 = 70;
                                    h16 = F_3 * 0.76;
                                    i16 = 80;
                                } else if (f15 < F_3 * 0.88)
                                {
                                    h15 = F_3 * 0.76;
                                    i15 = 80;
                                    h16 = F_3 * 0.88;
                                    i16 = 90;
                                } else if (f15 < F_3)
                                {
                                    h15 = F_3 * 0.88;
                                    i15 = 90;
                                    h16 = F_3;
                                    i16 = 100;
                                } else
                                {
                                    h15 = null;
                                    i15 = null;
                                    h16 = null;
                                    i16 = null;
                                }
                                break;
                            case"d40 DN32 (1 1/4'')":
                                if (a15 < F_3 * 0.05)
                                {
                                    c15 = 0;
                                    d15 = 10;
                                    c16 = F_3 * 0.05;
                                    d16 = 20;
                                } else if (a15 < F_3 * 0.17)
                                {
                                    c15 = F_3 * 0.05;
                                    d15 = 20;
                                    c16 = F_3 * 0.17;
                                    d16 = 30;
                                } else if (a15 < F_3 * 0.29)
                                {
                                    c15 = F_3 * 0.17;
                                    d15 = 30;
                                    c16 = F_3 * 0.29;
                                    d16 = 40;
                                } else if (a15 < F_3 * 0.41)
                                {
                                    c15 = F_3 * 0.29;
                                    d15 = 40;
                                    c16 = F_3 * 0.41;
                                    d16 = 50;
                                } else if (a15 < F_3 * 0.52)
                                {
                                    c15 = F_3 * 0.41;
                                    d15 = 50;
                                    c16 = F_3 * 0.52;
                                    d16 = 60;
                                } else if (a15 < F_3 * 0.64)
                                {
                                    c15 = F_3 * 0.52;
                                    d15 = 60;
                                    c16 = F_3 * 0.64;
                                    d16 = 70;
                                } else if (a15 < F_3 * 0.76)
                                {
                                    c15 = F_3 * 0.64;
                                    d15 = 70;
                                    c16 = F_3 * 0.76;
                                    d16 = 80;
                                } else if (a15 < F_3 * 0.88)
                                {
                                    c15 = F_3 * 0.76;
                                    d15 = 80;
                                    c16 = F_3 * 0.88;
                                    d16 = 90;
                                } else if (a15 < F_3)
                                {
                                    c15 = F_3 * 0.88;
                                    d15 = 90;
                                    c16 = F_3;
                                    d16 = 100;
                                } else
                                {
                                    c15 = null;
                                    d15 = null;
                                    c16 = null;
                                    d16 = null;
                                }


                                if (f15 < F_3 * 0.05)
                                {
                                    h15 = 0;
                                    i15 = 10;
                                    h16 = F_3 * 0.05;
                                    i16 = 20;
                                } else if (f15 < F_3 * 0.17)
                                {
                                    h15 = F_3 * 0.05;
                                    i15 = 20;
                                    h16 = F_3 * 0.17;
                                    i16 = 30;
                                } else if (f15 < F_3 * 0.29)
                                {
                                    h15 = F_3 * 0.17;
                                    i15 = 30;
                                    h16 = F_3 * 0.29;
                                    i16 = 40;
                                } else if (f15 < F_3 * 0.41)
                                {
                                    h15 = F_3 * 0.29;
                                    i15 = 40;
                                    h16 = F_3 * 0.41;
                                    i16 = 50;
                                } else if (f15 < F_3 * 0.52)
                                {
                                    h15 = F_3 * 0.41;
                                    i15 = 50;
                                    h16 = F_3 * 0.52;
                                    i16 = 60;
                                } else if (f15 < F_3 * 0.64)
                                {
                                    h15 = F_3 * 0.52;
                                    i15 = 60;
                                    h16 = F_3 * 0.64;
                                    i16 = 70;
                                } else if (f15 < F_3 * 0.76)
                                {
                                    h15 = F_3 * 0.64;
                                    i15 = 70;
                                    h16 = F_3 * 0.76;
                                    i16 = 80;
                                } else if (f15 < F_3 * 0.88)
                                {
                                    h15 = F_3 * 0.76;
                                    i15 = 80;
                                    h16 = F_3 * 0.88;
                                    i16 = 90;
                                } else if (f15 < F_3)
                                {
                                    h15 = F_3 * 0.88;
                                    i15 = 90;
                                    h16 = F_3;
                                    i16 = 100;
                                } else
                                {
                                    h15 = null;
                                    i15 = null;
                                    h16 = null;
                                    i16 = null;
                                }
                                break;
                            case"d50 DN40 (1 1/2'')":
                                if (a15 < F_3 * 0.10)
                                {
                                    c15 = 0;
                                    d15 = 10;
                                    c16 = F_3 * 0.10;
                                    d16 = 20;
                                } else if (a15 < F_3 * 0.22)
                                {
                                    c15 = F_3 * 0.10;
                                    d15 = 20;
                                    c16 = F_3 * 0.22;
                                    d16 = 30;
                                } else if (a15 < F_3 * 0.33)
                                {
                                    c15 = F_3 * 0.22;
                                    d15 = 30;
                                    c16 = F_3 * 0.33;
                                    d16 = 40;
                                } else if (a15 < F_3 * 0.44)
                                {
                                    c15 = F_3 * 0.33;
                                    d15 = 40;
                                    c16 = F_3 * 0.44;
                                    d16 = 50;
                                } else if (a15 < F_3 * 0.55)
                                {
                                    c15 = F_3 * 0.44;
                                    d15 = 50;
                                    c16 = F_3 * 0.55;
                                    d16 = 60;
                                } else if (a15 < F_3 * 0.66)
                                {
                                    c15 = F_3 * 0.55;
                                    d15 = 60;
                                    c16 = F_3 * 0.66;
                                    d16 = 70;
                                } else if (a15 < F_3 * 0.78)
                                {
                                    c15 = F_3 * 0.66;
                                    d15 = 70;
                                    c16 = F_3 * 0.78;
                                    d16 = 80;
                                } else if (a15 < F_3 * 0.89)
                                {
                                    c15 = F_3 * 0.78;
                                    d15 = 80;
                                    c16 = F_3 * 0.89;
                                    d16 = 90;
                                } else if (a15 < F_3)
                                {
                                    c15 = F_3 * 0.89;
                                    d15 = 90;
                                    c16 = F_3;
                                    d16 = 100;
                                } else
                                {
                                    c15 = null;
                                    d15 = null;
                                    c16 = null;
                                    d16 = null;
                                }


                                if (f15 < F_3 * 0.10)
                                {
                                    h15 = 0;
                                    i15 = 10;
                                    h16 = F_3 * 0.10;
                                    i16 = 20;
                                } else if (f15 < F_3 * 0.22)
                                {
                                    h15 = F_3 * 0.10;
                                    i15 = 20;
                                    h16 = F_3 * 0.22;
                                    i16 = 30;
                                } else if (f15 < F_3 * 0.33)
                                {
                                    h15 = F_3 * 0.22;
                                    i15 = 30;
                                    h16 = F_3 * 0.33;
                                    i16 = 40;
                                } else if (f15 < F_3 * 0.44)
                                {
                                    h15 = F_3 * 0.33;
                                    i15 = 40;
                                    h16 = F_3 * 0.44;
                                    i16 = 50;
                                } else if (f15 < F_3 * 0.55)
                                {
                                    h15 = F_3 * 0.44;
                                    i15 = 50;
                                    h16 = F_3 * 0.55;
                                    i16 = 60;
                                } else if (f15 < F_3 * 0.66)
                                {
                                    h15 = F_3 * 0.55;
                                    i15 = 60;
                                    h16 = F_3 * 0.66;
                                    i16 = 70;
                                } else if (f15 < F_3 * 0.78)
                                {
                                    h15 = F_3 * 0.66;
                                    i15 = 70;
                                    h16 = F_3 * 0.78;
                                    i16 = 80;
                                } else if (f15 < F_3 * 0.89)
                                {
                                    h15 = F_3 * 0.78;
                                    i15 = 80;
                                    h16 = F_3 * 0.89;
                                    i16 = 90;
                                } else if (f15 < F_3)
                                {
                                    h15 = F_3 * 0.88;
                                    i15 = 90;
                                    h16 = F_3;
                                    i16 = 100;
                                } else
                                {
                                    h15 = null;
                                    i15 = null;
                                    h16 = null;
                                    i16 = null;
                                }
                                break;
                            case"d63 DN50 (2'')":
                                if (a15 < F_3 * 0.0475)
                                {
                                    c15 = 0;
                                    d15 = 0;
                                    c16 = F_3 * 0.0475;
                                    d16 = 10;
                                } else if (a15 < F_3 * 0.1533)
                                {
                                    c15 = F_3 * 0.0475;
                                    d15 = 10;
                                    c16 = F_3 * 0.1533;
                                    d16 = 20;
                                } else if (a15 < F_3 * 0.2592)
                                {
                                    c15 = F_3 * 0.1533;
                                    d15 = 20;
                                    c16 = F_3 * 0.2592;
                                    d16 = 30;
                                } else if (a15 < F_3 * 0.365)
                                {
                                    c15 = F_3 * 0.2592;
                                    d15 = 30;
                                    c16 = F_3 * 0.365;
                                    d16 = 40;
                                } else if (a15 < F_3 * 0.47)
                                {
                                    c15 = F_3 * 0.365;
                                    d15 = 40;
                                    c16 = F_3 * 0.47;
                                    d16 = 50;
                                } else if (a15 < F_3 * 0.5767)
                                {
                                    c15 = F_3 * 0.47;
                                    d15 = 50;
                                    c16 = F_3 * 0.5767;
                                    d16 = 60;
                                } else if (a15 < F_3 * 0.6825)
                                {
                                    c15 = F_3 * 0.5767;
                                    d15 = 60;
                                    c16 = F_3 * 0.6825;
                                    d16 = 70;
                                } else if (a15 < F_3 * 0.7883)
                                {
                                    c15 = F_3 * 0.6825;
                                    d15 = 70;
                                    c16 = F_3 * 0.7883;
                                    d16 = 80;
                                } else if (a15 < F_3 * 0.8942)
                                {
                                    c15 = F_3 * 0.7883;
                                    d15 = 80;
                                    c16 = F_3 * 0.8942;
                                    d16 = 90;
                                } else if (a15 < F_3)
                                {
                                    c15 = F_3 * 0.8942;
                                    d15 = 90;
                                    c16 = F_3;
                                    d16 = 100;
                                } else
                                {
                                    c15 = null;
                                    d15 = null;
                                    c16 = null;
                                    d16 = null;
                                }


                                if (f15 < F_3 * 0.0475)
                                {
                                    h15 = 0;
                                    i15 = 0;
                                    h16 = F_3 * 0.0475;
                                    i16 = 10;
                                } else if (f15 < F_3 * 0.1533)
                                {
                                    h15 = F_3 * 0.0475;
                                    i15 = 10;
                                    h16 = F_3 * 0.1533;
                                    i16 = 20;
                                } else if (f15 < F_3 * 0.2592)
                                {
                                    h15 = F_3 * 0.1533;
                                    i15 = 20;
                                    h16 = F_3 * 0.2592;
                                    i16 = 30;
                                } else if (f15 < F_3 * 0.365)
                                {
                                    h15 = F_3 * 0.2592;
                                    i15 = 30;
                                    h16 = F_3 * 0.365;
                                    i16 = 40;
                                } else if (f15 < F_3 * 0.47)
                                {
                                    h15 = F_3 * 0.365;
                                    i15 = 40;
                                    h16 = F_3 * 0.47;
                                    i16 = 50;
                                } else if (f15 < F_3 * 0.5767)
                                {
                                    h15 = F_3 * 0.47;
                                    i15 = 50;
                                    h16 = F_3 * 0.5767;
                                    i16 = 60;
                                } else if (f15 < F_3 * 0.6825)
                                {
                                    h15 = F_3 * 0.5767;
                                    i15 = 60;
                                    h16 = F_3 * 0.6825;
                                    i16 = 70;
                                } else if (f15 < F_3 * 0.7883)
                                {
                                    h15 = F_3 * 0.6825;
                                    i15 = 70;
                                    h16 = F_3 * 0.7883;
                                    i16 = 80;
                                } else if (f15 < F_3 * 0.8942)
                                {
                                    h15 = F_3 * 0.7883;
                                    i15 = 80;
                                    h16 = F_3 * 0.8942;
                                    i16 = 90;
                                } else if (f15 < F_3)
                                {
                                    h15 = F_3 * 0.8942;
                                    i15 = 90;
                                    h16 = F_3;
                                    i16 = 100;
                                } else
                                {
                                    h15 = null;
                                    i15 = null;
                                    h16 = null;
                                    i16 = null;
                                }
                                break;
                        }


                        break;
                    case "Diaphragm Valve Type 514 - 517":


                        if (a15 < F_3 * 0.04)
                        {
                            c15 = 0;
                            d15 = 0;
                            c16 = F_3 * 0.04;
                            d16 = 9;
                        } else if (a15 < F_3 * 0.11)
                        {
                            c15 = F_3 * 0.04;
                            d15 = 9;
                            c16 = F_3 * 0.11;
                            d16 = 18;
                        } else if (a15 < F_3 * 0.2162)
                        {
                            c15 = F_3 * 0.11;
                            d15 = 18;
                            c16 = F_3 * 0.2162;
                            d16 = 27;
                        } else if (a15 < F_3 * 0.3264)
                        {
                            c15 = F_3 * 0.2162;
                            d15 = 27;
                            c16 = F_3 * 0.3264;
                            d16 = 36;
                        } else if (a15 < F_3 * 0.4387)
                        {
                            c15 = F_3 * 0.3264;
                            d15 = 36;
                            c16 = F_3 * 0.4387;
                            d16 = 45;
                        } else if (a15 < F_3 * 0.5530)
                        {
                            c15 = F_3 * 0.4387;
                            d15 = 45;
                            c16 = F_3 * 0.5530;
                            d16 = 55;
                        } else if (a15 < F_3 * 0.69)
                        {
                            c15 = F_3 * 0.5530;
                            d15 = 55;
                            c16 = F_3 * 0.69;
                            d16 = 64;
                        } else if (a15 < F_3 * 0.83)
                        {
                            c15 = F_3 * 0.69;
                            d15 = 64;
                            c16 = F_3 * 0.83;
                            d16 = 73;
                        } else if (a15 < F_3 * 0.94)
                        {
                            c15 = F_3 * 0.83;
                            d15 = 73;
                            c16 = F_3 * 0.94;
                            d16 = 82;
                        } else if (a15 < F_3 * 0.99)
                        {
                            c15 = F_3 * 0.94;
                            d15 = 82;
                            c16 = F_3 * 0.99;
                            d16 = 91;
                        } else if (a15 < F_3)
                        {
                            c15 = F_3 * 0.99;
                            d15 = 91;
                            c16 = F_3;
                            d16 = 100;
                        } else
                        {
                            c15 = null;
                            d15 = null;
                            c16 = null;
                            d16 = null;
                        }


                        if (f15 < F_3 * 0.04)
                        {
                            h15 = 0;
                            i15 = 0;
                            h16 = F_3 * 0.04;
                            i16 = 9;
                        } else if (f15 < F_3 * 0.11)
                        {
                            h15 = F_3 * 0.04;
                            i15 = 9;
                            h16 = F_3 * 0.11;
                            i16 = 18;
                        } else if (f15 < F_3 * 0.22)
                        {
                            h15 = F_3 * 0.11;
                            i15 = 18;
                            h16 = F_3 * 0.22;
                            i16 = 27;
                        } else if (f15 < F_3 * 0.33)
                        {
                            h15 = F_3 * 0.22;
                            i15 = 27;
                            h16 = F_3 * 0.33;
                            i16 = 36;
                        } else if (f15 < F_3 * 0.44)
                        {
                            h15 = F_3 * 0.33;
                            i15 = 36;
                            h16 = F_3 * 0.44;
                            i16 = 45;
                        } else if (f15 < F_3 * 0.55)
                        {
                            h15 = F_3 * 0.44;
                            i15 = 45;
                            h16 = F_3 * 0.55;
                            i16 = 55;
                        } else if (f15 < F_3 * 0.69)
                        {
                            h15 = F_3 * 0.55;
                            i15 = 55;
                            h16 = F_3 * 0.69;
                            i16 = 64;
                        } else if (f15 < F_3 * 0.83)
                        {
                            h15 = F_3 * 0.69;
                            i15 = 64;
                            h16 = F_3 * 0.83;
                            i16 = 73;
                        } else if (f15 < F_3 * 0.94)
                        {
                            h15 = F_3 * 0.83;
                            i15 = 73;
                            h16 = F_3 * 0.94;
                            i16 = 82;
                        } else if (f15 < F_3 * 0.99)
                        {
                            h15 = F_3 * 0.94;
                            i15 = 82;
                            h16 = F_3 * 0.99;
                            i16 = 91;
                        } else if (f15 < F_3)
                        {
                            h15 = F_3 * 0.99;
                            i15 = 91;
                            h16 = F_3;
                            i16 = 100;
                        } else
                        {
                            h15 = null;
                            i15 = null;
                            h16 = null;
                            i16 = null;
                        }


                        break;
                    case "Diaphragm Valve Type 317 - 025":

                        if (a15 < F_3 * 0.06)
                        {
                            c15 = 0;
                            d15 = 0;
                            c16 = F_3 * 0.06;
                            d16 = 10;
                        } else if (a15 < F_3 * 0.24)
                        {
                            c15 = F_3 * 0.06;
                            d15 = 10;
                            c16 = F_3 * 0.24;
                            d16 = 20;
                        } else if (a15 < F_3 * 0.49)
                        {
                            c15 = F_3 * 0.24;
                            d15 = 20;
                            c16 = F_3 * 0.49;
                            d16 = 30;
                        } else if (a15 < F_3 * 0.73)
                        {
                            c15 = F_3 * 0.49;
                            d15 = 30;
                            c16 = F_3 * 0.73;
                            d16 = 40;
                        } else if (a15 < F_3 * 0.86)
                        {
                            c15 = F_3 * 0.73;
                            d15 = 40;
                            c16 = F_3 * 0.86;
                            d16 = 50;
                        } else if (a15 < F_3 * 0.93)
                        {
                            c15 = F_3 * 0.86;
                            d15 = 50;
                            c16 = F_3 * 0.93;
                            d16 = 60;
                        } else if (a15 < F_3 * 0.96)
                        {
                            c15 = F_3 * 0.93;
                            d15 = 60;
                            c16 = F_3 * 0.96;
                            d16 = 70;
                        } else if (a15 < F_3 * 0.98)
                        {
                            c15 = F_3 * 0.96;
                            d15 = 70;
                            c16 = F_3 * 0.98;
                            d16 = 80;
                        } else if (a15 < F_3 * 0.99)
                        {
                            c15 = F_3 * 0.98;
                            d15 = 80;
                            c16 = F_3 * 0.99;
                            d16 = 90;
                        } else if (a15 < F_3)
                        {
                            c15 = F_3;
                            d15 = 90;
                            c16 = F_3;
                            d16 = 100;
                        } else
                        {
                            c15 = null;
                            d15 = null;
                            c16 = null;
                            d16 = null;
                        }


                        if (f15 < F_3 * 0.06)
                        {
                            h15 = 0;
                            i15 = 0;
                            h16 = F_3 * 0.06;
                            i16 = 10;
                        } else if (f15 < F_3 * 0.24)
                        {
                            h15 = F_3 * 0.06;
                            i15 = 10;
                            h16 = F_3 * 0.24;
                            i16 = 20;
                        } else if (f15 < F_3 * 0.49)
                        {
                            h15 = F_3 * 0.24;
                            i15 = 20;
                            h16 = F_3 * 0.49;
                            i16 = 30;
                        } else if (f15 < F_3 * 0.73)
                        {

                            h15 = F_3 * 0.49;
                            i15 = 30;
                            h16 = F_3 * 0.73;
                            i16 = 40;
                        } else if (f15 < F_3 * 0.86)
                        {
                            h15 = F_3 * 0.73;
                            i15 = 40;
                            h16 = F_3 * 0.86;
                            i16 = 50;
                        } else if (f15 < F_3 * 0.93)
                        {
                            h15 = F_3 * 0.86;
                            i15 = 50;
                            h16 = F_3 * 0.93;
                            i16 = 60;
                        } else if (f15 < F_3 * 0.96)
                        {
                            h15 = F_3 * 0.93;
                            i15 = 60;
                            h16 = F_3 * 0.96;
                            i16 = 70;
                        } else if (f15 < F_3 * 0.98)
                        {
                            h15 = F_3 * 0.96;
                            i15 = 70;
                            h16 = F_3 * 0.98;
                            i16 = 80;
                        } else if (f15 < F_3 * 0.99)
                        {
                            h15 = F_3 * 0.98;
                            i15 = 80;
                            h16 = F_3 * 0.99;
                            i16 = 90;
                        } else if (f15 < F_3)
                        {
                            h15 = F_3 * 0.99;
                            i15 = 91;
                            h16 = F_3;
                            i16 = 100;
                        } else
                        {
                            h15 = null;
                            i15 = null;
                            h16 = null;
                            i16 = null;
                        }

                        break;
                    case "Butterfly Valve Type 567 - 568":

                        if (a15 < F_3 * 0.01)
                        {
                            c15 = 0;
                            d15 = 10;
                            c16 = F_3 * 0.01;
                            d16 = 20;
                        } else if (a15 < F_3 * 0.05)
                        {
                            c15 = F_3 * 0.01;
                            d15 = 20;
                            c16 = F_3 * 0.05;
                            d16 = 30;
                        } else if (a15 < F_3 * 0.12)
                        {
                            c15 = F_3 * 0.05;
                            d15 = 30;
                            c16 = F_3 * 0.12;
                            d16 = 40;
                        } else if (a15 < F_3 * 0.24)
                        {
                            c15 = F_3 * 0.12;
                            d15 = 40;
                            c16 = F_3 * 0.24;
                            d16 = 50;
                        } else if (a15 < F_3 * 0.39)
                        {
                            c15 = F_3 * 0.24;
                            d15 = 50;
                            c16 = F_3 * 0.39;
                            d16 = 60;
                        } else if (a15 < F_3 * 0.56)
                        {
                            c15 = F_3 * 0.39;
                            d15 = 60;
                            c16 = F_3 * 0.56;
                            d16 = 70;
                        } else if (a15 < F_3 * 0.74)
                        {
                            c15 = F_3 * 0.56;
                            d15 = 70;
                            c16 = F_3 * 0.74;
                            d16 = 80;
                        } else if (a15 < F_3 * 0.90)
                        {
                            c15 = F_3 * 0.74;
                            d15 = 80;
                            c16 = F_3 * 0.90;
                            d16 = 90;
                        } else if (a15 < F_3)
                        {
                            c15 = F_3 * 0.90;
                            d15 = 90;
                            c16 = F_3;
                            d16 = 100;
                        } else
                        {
                            c15 = null;
                            d15 = null;
                            c16 = null;
                            d16 = null;
                        }


                        if (f15 < F_3 * 0.01)
                        {
                            h15 = 0;
                            i15 = 10;
                            h16 = F_3 * 0.01;
                            i16 = 20;
                        } else if (f15 < F_3 * 0.05)
                        {
                            h15 = F_3 * 0.01;
                            i15 = 20;
                            h16 = F_3 * 0.05;
                            i16 = 30;
                        } else if (f15 < F_3 * 0.12)
                        {
                            h15 = F_3 * 0.05;
                            i15 = 30;
                            h16 = F_3 * 0.12;
                            i16 = 40;
                        } else if (f15 < F_3 * 0.24)
                        {
                            h15 = F_3 * 0.12;
                            i15 = 40;
                            h16 = F_3 * 0.24;
                            i16 = 50;
                        } else if (f15 < F_3 * 0.39)
                        {
                            h15 = F_3 * 0.24;
                            i15 = 50;
                            h16 = F_3 * 0.39;
                            i16 = 60;
                        } else if (f15 < F_3 * 0.56)
                        {
                            h15 = F_3 * 0.39;
                            i15 = 60;
                            h16 = F_3 * 0.56;
                            i16 = 70;
                        } else if (f15 < F_3 * 0.74)
                        {
                            h15 = F_3 * 0.56;
                            i15 = 70;
                            h16 = F_3 * 0.74;
                            i16 = 80;
                        } else if (f15 < F_3 * 0.90)
                        {
                            h15 = F_3 * 0.74;
                            i15 = 80;
                            h16 = F_3 * 0.90;
                            i16 = 90;
                        } else if (f15 < F_3)
                        {
                            h15 = F_3 * 0.90;
                            i15 = 90;
                            h16 = F_3;
                            i16 = 100;
                        } else
                        {
                            h15 = null;
                            i15 = null;
                            h16 = null;
                            i16 = null;
                        }

                        break;



                  case "Butterfly Valve Type 565":

                    if (a15 < F_3 * 0.01)
                    {
                      c15 = 0;
                      d15 = 0;
                      c16 = F_3 * 0.01;
                      d16 = 11;
                    } else if (a15 < F_3 * 0.03)
                    {
                      c15 = F_3 * 0.01;
                      d15 = 11;
                      c16 = F_3 * 0.03;
                      d16 = 17;
                    } else if (a15 < F_3 * 0.05)
                    {
                      c15 = F_3 * 0.03;
                      d15 = 17;
                      c16 = F_3 * 0.05;
                      d16 = 22;
                    } else if (a15 < F_3 * 0.09)
                    {
                      c15 = F_3 * 0.05;
                      d15 = 22;
                      c16 = F_3 * 0.09;
                      d16 = 33;
                    } else if (a15 < F_3 * 0.16)
                    {
                      c15 = F_3 * 0.09;
                      d15 = 33;
                      c16 = F_3 * 0.16;
                      d16 = 44;
                    } else if (a15 < F_3 * 0.2)
                    {
                      c15 = F_3 * 0.16;
                      d15 = 44;
                      c16 = F_3 * 0.2;
                      d16 = 50;
                    } else if (a15 < F_3 * 0.27)
                    {
                      c15 = F_3 * 0.2;
                      d15 = 50;
                      c16 = F_3 * 0.27;
                      d16 = 56;
                    } else if (a15 < F_3 * 0.42)
                    {
                      c15 = F_3 * 0.27;
                      d15 = 56;
                      c16 = F_3 * 0.42;
                      d16 = 67;
                    } else if (a15 < F_3 * 0.65)
                    {
                      c15 = F_3 * 0.42;
                      d15 = 67;
                      c16 = F_3 * 0.65;
                      d16 = 78;
                    } else if (a15 < F_3 * 0.80)
                    {
                      c15 = F_3 * 0.65;
                      d15 = 78;
                      c16 = F_3 * 0.80;
                      d16 = 83;
                    } else if (a15 < F_3 * 0.9)
                    {
                      c15 = F_3 * 0.80;
                      d15 = 83;
                      c16 = F_3 * 0.9;
                      d16 = 89;
                    } else if (a15 < F_3 * 0.98)
                    {
                      c15 = F_3 * 0.9;
                      d15 = 89;
                      c16 = F_3 * 0.98;
                      d16 = 94;
                    } else if (a15 < F_3)
                    {
                      c15 = F_3 * 0.98;
                      d15 = 94;
                      c16 = F_3;
                      d16 = 100;
                    } else
                    {
                      c15 = null;
                      d15 = null;
                      c16 = null;
                      d16 = null;
                    }


                    if (f15 < F_3 * 0.01)
                    {
                      h15 = 0;
                      i15 = 0;
                      h16 = F_3 * 0.01;
                      i16 = 11;
                    } else if (f15 < F_3 * 0.03)
                    {
                      h15 = F_3 * 0.01;
                      i15 = 11;
                      h16 = F_3 * 0.03;
                      i16 = 17;
                    } else if (f15 < F_3 * 0.05)
                    {
                      h15 = F_3 * 0.03;
                      i15 = 17;
                      h16 = F_3 * 0.05;
                      i16 = 22;
                    } else if (f15 < F_3 * 0.09)
                    {
                      h15 = F_3 * 0.05;
                      i15 = 22;
                      h16 = F_3 * 0.09;
                      i16 = 33;
                    } else if (f15 < F_3 * 0.16)
                    {
                      h15 = F_3 * 0.09;
                      i15 = 33;
                      h16 = F_3 * 0.16;
                      i16 = 44;
                    } else if (f15 < F_3 * 0.20)
                    {
                      h15 = F_3 * 0.16;
                      i15 = 44;
                      h16 = F_3 * 0.20;
                      i16 = 50;
                    } else if (f15 < F_3 * 0.27)
                    {
                      h15 = F_3 * 0.20;
                      i15 = 50;
                      h16 = F_3 * 0.27;
                      i16 = 56;
                    } else if (f15 < F_3 * 0.42)
                    {
                      h15 = F_3 * 0.27;
                      i15 = 56;
                      h16 = F_3 * 0.42;
                      i16 = 67;
                    } else if (f15 < F_3 * 0.65)
                    {
                      h15 = F_3 * 0.42;
                      i15 = 67;
                      h16 = F_3 * 0.65;
                      i16 = 78;
                    } else if (f15 < F_3 * 0.80)
                    {
                      h15 = F_3 * 0.65;
                      i15 = 78;
                      h16 = F_3 * 0.80;
                      i16 = 83;
                    } else if (f15 < F_3 * 0.90)
                    {
                      h15 = F_3 * 0.80;
                      i15 = 83;
                      h16 = F_3 * 0.90;
                      i16 = 89;
                    } else if (f15 < F_3 * 0.98)
                    {
                      h15 = F_3 * 0.90;
                      i15 = 89;
                      h16 = F_3 * 0.98;
                      i16 = 94;
                    } else if (f15 < F_3)
                    {
                      h15 = F_3 * 0.98;
                      i15 = 94;
                      h16 = F_3;
                      i16 = 100;
                    } else
                    {
                      h15 = null;
                      i15 = null;
                      h16 = null;
                      i16 = null;
                    }

                    break;


                }


                var e15 = d15 + (d16 - d15) / (c16 - c15) * (a15 - c15); //Math.round(d15 + (d16 - d15) / (c16 - c15) * (a15 - c15)); //edit 20240730
                var j15 = i15 + (i16 - i15) / (h16 - h15) * (f15 - h15); //Math.round(i15 + (i16 - i15) / (h16 - h15) * (f15 - h15)); //edit 20240730

                console.clear();
                console.log("F3", F_3);
                console.log("G3", G_3);
                console.log("I3",I_3);
                console.log("C3", C_3);
                console.log("E3", E_3);
                console.log("H3", H_3);
                
                console.log("J3", J_3);
                console.log("--------------");
                console.log("a15", a15);
                console.log("c15 - Minimaler Fi", c15);
                console.log("c16 - Minimaler Fi", c16);
                console.log("d15 - Minimaler Ei", d15);
                console.log("d16 - Minimaler Ei", d16);
                // console.log("g15", g15);
                console.log("i15 - Maximaler Ei", i15);
                console.log("i16 - Maximaler Ei", i16);
                console.log("h15 - Maximaler Fi", h15);
                console.log("h16 - Maximaler Fi", h16);

                console.log("f15 - Maximaler Durchflusswert in l/min", f15);
                console.log("e15 - Minimaler Ex", e15);
                console.log("j15 - Maximaler Ex", j15);

                let DN = parseInt(this.$refs.selectDimension2.val().substring(this.$refs.selectDimension2.val().indexOf("DN")+2, this.$refs.selectDimension2.val().indexOf("DN")+5));
                let r = DN / 2 / 1000;
                let A = Math.PI * r * r;
                let Q = I_3 / 3600;
                let v = Q / A;

                console.log("DN", DN);
                console.log("r", r);
                console.log("A", A);
                console.log("Q", Q);
                console.log("v - Volumenstrom", v);

                console.log("=====================");

                var imageWidth = 1348;//1400;
                var coordsXPos = 242;//242;
                var coordsWidth = 1099;//1052;


                var onePercent = imageWidth / 100;
                var zeroPos = coordsXPos / onePercent;
                var oneCoordPercent = (coordsWidth / onePercent) / 100;
                var posX = oneCoordPercent * Math.min(e15, 100) + zeroPos;

                // console.log("min", e15 + "% - " + (d15 + (d16 - d15) / (c16 - c15) * (a15 - c15)));
                // console.log("max", j15 + "% - " + (i15 + (i16 - i15) / (h16 - h15) * (f15 - h15)));

              $("#error_cavitation").hide();
              // if (j15 > max) {
              //   $("#error_cavitation").show();
              // }

              $("#error_pressureDrop").hide();
              $("#error_maxFlow").hide();

              if (($("#inletPressure").val() - $("#outletPressure").val()) > ($("#inletPressure").val() * 15 / 100))
              {
                $("#error_pressureDrop").show();
              }
              if (v > 3) {
                $("#error_maxFlow").show();
              }

              window.aDurchfluss = aDurchfluss;
                $("#openingLeft").css("left", zeroPos + "%");
                $("#openingLeft").css("width", min * oneCoordPercent + "%");

                $("#locatorLeft").show();
                $("#locatorRight").show();
                $("#openingRight").css("left", zeroPos + max * oneCoordPercent + "%");
                $("#openingRight").css("width", (100 - max) * oneCoordPercent + "%");
                $("#locatorLeft").css("left", posX + "%");
              wordingLeftLocator = $gettext("Opening angle: @val@% / Flow: ");
              wordingRightLocator = $gettext("Opening angle: @val@% / Flow: ");
                $("#locatorLeft").prop("title", wordingLeftLocator.replace("@val@", Math.round(e15)) + " " + $("#flowQ1").val() + unitFlow);
                if (isNaN(posX)) $("#locatorLeft").hide();
                posX = oneCoordPercent * Math.min(j15, 100) + zeroPos;
                $("#locatorRight").css("left", posX + "%");
                $("#locatorRight").prop("title", wordingRightLocator.replace("@val@", Math.round(j15)) + " " + $("#flowQ2").val() + unitFlow);
                if (isNaN(posX)) $("#locatorRight").hide();

                $("#headline").text($("#selectValve option:selected").text() + " " + that.$refs.selectDimension2.val());
                $("#selectValveP").val(that.$refs.selectValve.val());
                $("#selectDimensionP").val(that.$refs.selectDimension.val());
                $("#selectDimension2P").val(that.$refs.selectDimension2.val());
            },
            getUrlParameter: function (sParam) {
                var sPageURL = decodeURIComponent(window.location.search.substring(1)),
                    sURLVariables = sPageURL.split('&'),
                    sParameterName,
                    i;
                for (i = 0; i < sURLVariables.length; i++)
                {
                    sParameterName = sURLVariables[i].split('=');
                    if (sParameterName[0] === sParam)
                    {
                        return sParameterName[1] === undefined ? true : sParameterName[1];
                    }
                }
            },
        }
    }
</script>

<style scoped>
    @font-face {
        font-family: "DINNextLTW05-Regular";
        src: url("../assets/DINNextLTW05-Regular.eot?#iefix");
        src: url("../assets/DINNextLTW05-Regular.eot?#iefix") format("eot"),
        url("../assets/DINNextLTW05-Regular.woff2") format("woff2"),
        url("../assets/DINNextLTW05-Regular.woff") format("woff"),
        url("../assets/DINNextLTW05-Regular.ttf") format("truetype");
    }

    @font-face {
        font-family: "GlyphaLTW05-65Bold";
        src: url("../assets/GlyphaLTW05-65Bold.eot?#iefix");
        src: url("../assets/GlyphaLTW05-65Bold.eot?#iefix") format("eot"),
        url("../assets/GlyphaLTW05-65Bold.woff2") format("woff2"),
        url("../assets/GlyphaLTW05-65Bold.woff") format("woff"),
        url("../assets/GlyphaLTW05-65Bold.ttf") format("truetype");
    }

    @font-face {
        font-family: "DINNextLTW01-Medium";
        src: url("../assets/DINNextLTW01-Medium.eot?#iefix");
        src: url("../assets/DINNextLTW01-Medium.eot?#iefix") format("eot"),
        url("../assets/DINNextLTW01-Medium.woff2") format("woff2"),
        url("../assets/DINNextLTW01-Medium.woff") format("woff"),
        url("../assets/DINNextLTW01-Medium.ttf") format("truetype");
    }

    .myerror {
      /*margin-top:-18px;*/
      text-align: left;
      font-size: 12px;
      color: #ff0000;
      display: none;
    }
    h1, a {
        text-decoration: none !important;
        color: #000;
        font-family: DINNextLTW05-Regular, sans-serif;
        font-size: 22px;
        line-height: 1.5625rem;

    }

    select,
    input {
        -webkit-font-smoothing: antialiased;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-appearance: none;
        background-color: #f0f0f0;
        border: 0.1875rem solid #f0f0f0;
        border-radius: 0;
        display: block;
        font-family: DINNextLTW05-Regular, sans-serif;
        font-size: 1.125rem;
        height: 2.5rem;
        padding: 0.3125rem 2.375rem 0.3125rem calc(0.1875rem + 0.3125rem);
        width: 100%;
        outline: none;
    }
    input {
      height:42.5px;
    }
    select:focus {
        background-color: #fff;
        border-color: #f0f0f0;
    }
    select option {
        font-family: "DINNextLTW05-Regular", sans-serif;
    }
    .selectWrapper, .inputWrapper {
        color: #000;
        font-family: "DINNextLTW05-Regular", sans-serif;
        font-size: 16px;
        line-height: 1.5;
        -webkit-font-smoothing: antialiased;
        box-sizing: border-box;
        flex-basis: 100%;
        margin-top: 8px;
        position: relative;
    }

    .selectWrapper::after {
        content: "";
        display: block;
        /*background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 7.6l-6-6L1.6 0 6 4.4 10.4 0 12 1.6l-6 6z' fill='%2333ADFF' fill-rule='evenodd'/%3E%3C/svg%3E");*/
        background-position: center;
        background-size: 0.75rem 0.5rem;
        background-repeat: no-repeat;
        height: 2.5rem;
        pointer-events: none;
        position: absolute;
        right: 1rem;
        top: 0;
        width: 0.75rem;
    }
    input[type="text"] {
        margin-bottom: 10px;
    }

    input[type="number"] {
        margin-top: 2px;
        margin-right: 2px;
        margin-bottom: 18px;
    }
    #productImg {
        vertical-align: middle;
    }
    #bBerechnen {
      background-color: #ff6600;
      border:0;
      color: #FFFFFF;
      padding: 1.25rem 2.5rem;
      font-size: 20px;
      font-weight: 400;
      font-family: "DINNextLTW05-Regular", Arial, sans-serif;
      cursor: pointer;
    }
    .imageWrapper {
        border: 1px solid #bbb;
        /*height: 295px;*/
        height: 314px;
        /*margin-top: 27px;*/
        margin-top: 33px;
    }
    .helper {
        display: inline-block;
        height: 100%;
        vertical-align: middle;
    }
    label {
        _font-size: 10px;
    }
    .hidePrint {
        display:block;
    }
    .showPrint {
        display: none;
    }
    .main {
        width: 90vw;
        margin-left: auto;
        margin-right: auto;
        max-width: 1280px;
        border: 1px solid #bbb;
        padding: 20px;
        font-family: "DINNextLTW05-Regular", Arial, sans-serif;
    }
    #myDiagram {
        width: 90vw;
        margin-left: auto;
        margin-right: auto;
        max-width: 1280px;
        border: 1px solid #bbb;
        border-top: 0;
        padding: 20px;
        font-family: "DINNextLTW05-Regular", Arial, sans-serif;
        overflow: hidden;
    }
    .mainLeft {
        width: 40%;
        display: inline;
        float: left;
    }

    .mainRight {
        width: 52%;
        margin-left: 5%;
        display: inline;
        float: left;
        margin-right:3%;
        /*padding:20px;*/
    }

    .divShadow {
        margin-bottom: 36px;
        border: 1px solid #eaeaea;
        border-left: 1px solid #f6f6f6;
        -webkit-box-shadow: 1px 1px 3px #aaa;
        -moz-box-shadow: 1px 1px 3px #aaa;
        box-shadow: 1px 1px 3px #aaa;
        padding-left: 10px;
    }

    .row {
        width: 100%;
        margin-bottom: 20px;

    }

    .halfRow {
        width: 32%;
        display: inline;
        float: left;
        margin-right:1.5%;
    }

    .row80 {
        width: 80%;
        display: inline;
        float: left;
    }

    .row40 {
        width: 45%;
        display: inline;
        float: left;
    }
    .row90 {
        width: 90%;
        display: inline;
        float: left;
        margin-bottom: 20px;
    }
    .row20 {
        width: 10%;
        display: inline;
        float: left;
        margin-top: 3px;
    }

    .row20::after {
        clear: both;
    }
    #imgDiagram, #pProductImg {
        display: block !important;
    }
    .mainp {
        margin-left:20px;
        font-family: DINNextLTW05-Regular !important;
    }
    .plus {
        background: #ff7e00 url("../assets/icons.png") no-repeat -85px -3297px;
        width: 16px;
        height: 16px;
        margin-top: 14px;
        cursor: pointer;
        margin-left: 124%;
    }

    .printminus {
        background: #f07d0f url('../assets/icons.png') -85px -3397px no-repeat !important;
    }

    .infoI {
        background: url(../assets/infoI.png) no-repeat;
        bottom: 1px;
        height: 20px;
        width: 20px;
        cursor: pointer;
        z-index: 1000;
        vertical-align: sub;
        float: right;
        margin-top: 0px;
    }

    .myLabel {
        font-size: 16px;
        text-align: left;
    }

    .tooltip {
        position: relative;
        width: 1px;
        height: 1px;
        display: inline;
        cursor: pointer;
    }

    .tipp {
        position: absolute;
        display: none;
        padding: 10px;
        background: #ffffff;
        top: 0;
        left: 10px;
        cursor: pointer;
        z-index: 999999;

        min-width: 125px;
        -webkit-box-shadow: 1px 1px 3px #aaa;
        -moz-box-shadow: 1px 1px 3px #aaa;
        box-shadow: 1px 1px 3px #aaa;
    }
    .myblock {
        display: inline;
        float: left;
        width: 99%;
    }
    .inputNumber {
        /*width: 60%*/
    }

    #outerImage {
        position: relative;
        left: -3%;
    }

    #locatorLeft {

    }
    #myDiagram {
        text-align: left;
    }
    .locator {
        width: 6px;
        position: absolute;
        top: 3%;
        left: 11.67%;
        height: 79%;
        /*z-index: 100;*/
    }
    .openingRed {
        height:80%;
        background-color: #ff0000 !important;
        opacity: 0.0;

        position: absolute;
        z-index: 10;
        top: 3%;
    }
    .arrow {
        float: left;

    }

    .clearfix {
        clear: both;
    }

    .printLogo {
        display: none;
    }
    .flowValue {
        width: 21%;
        left: -4%;
        font-size: min(1.3vw,18px);
        max-font-size: 13px;
        position: absolute;
        text-align: right;
    }
    .pValue {
        width: 14%;
        top: 84%;
        font-size: min(1.3vw,18px);
        max-font-size: 13px;
        position:absolute;
        text-align: right;
    }
    .oAngle {
        top: 93%;
        left: 53%;
        font-size: min(1.3vw,18px);
        max-font-size: 13px;
        position: absolute;
        text-align: center;
    }
    .dFlow {
        width: 27%;
        top: 42%;
        left: -9.2%;
        position: absolute;
        font-size: min(1.3vw,18px);
        text-align: center;
        -moz-transform: rotate(-90deg);
        -ms-transform: rotate(-90deg);
        -o-transform: rotate(-90deg);
        -webkit-transform: rotate(-90deg);
    }

    .myTooltip {
        background-color: #fff;
        border: 1px solid #999;
        color: #000;
    }

    .tooltip-arrow {
        display: none !important;
        border-color: red;
    }
    #sendEmail:before {
        content: url("../assets/email.png");
        margin-right: 8px;
        vertical-align: middle;
    }
    #sendEmail {
        color: #00abfe;
        font-size: 16px;
        cursor: pointer;
        font-family: "DINNextLTW01-Medium", Arial;
    }
    #doPrint {
        color: #00abfe;
        font-size: 16px;
        cursor: pointer;
        margin-right: 35px;
        font-family: "DINNextLTW01-Medium", Arial;
    }
    #doPrint:before {
        content: url("../assets/print.png");
        margin-right: 8px;
        vertical-align: middle;
    }
    /*@media (max-width: 788px) {*/
    @media screen and (max-width:1000px) {
        .hideMobile {
            display: none;
        }
        .mainLeft {
            width: 100%;

        }
        .main {
            width: unset;
        }
        .halfRow {
            width: 100%;
        }
        .myblock {
            width: 100%;
        }
        .mainRight {
            width: 94%;
            margin-left: 3vw;
        }
        .tipp {
            left: -200px;
            max-width: 99%;
        }
        .flowValue, .pValue, .oAngle, .dFlow {
            font-size: 2.6vw;
        }
        #doPrint {
            margin-left: 6px;
        }
        #sendEmail {
            margin-left: 6px;
        }
        .imageWrapper {
            margin-bottom: 25px;
        }
        #myDiagram {
            width: unset;
        }
    }

    @media print {
        * {
            -webkit-print-color-adjust: exact;
            color-adjust: exact;
        }
        .row {
            width:100%;
        }

        mainp{
            margin:0;
            padding:0;
            width:100%;
        }
        .flowValue, .pValue, .oAngle, .dFlow {
            font-size: 2.4vw;
        }

        h2 {
            margin-top:-2px;
            font-size:30px;
            color: #000;
        }
        .mainLeft {
            width: 50%;
            display:inline;
            float:left;
            text-align: left;
        }
        .mainRight {
            width:50%;
            diplay:inline;
            margin-right:0;
            text-align: left;
        }
        .printLogo {
            display: block;
            margin-left:455px;
            margin-bottom:20px;
        }
        .hidePrint {
            display:none;
        }
        .showPrint {
            display: block;
        }
        .divShadow {
            border:0 !important;
            -webkit-box-shadow: 0;
            -moz-box-shadow: 0;
            box-shadow: 0;
        }
        .pValue, .oAngle, .flowValue, .dFlow {
            font-size:12px;
        }
        #pDiagramm {
            padding-left:2%;
            border:0;
        }
        #myDiagram {
          border: 0;
          margin-top: 0 !important;
          margin-bottom: 0 !important;
          padding-top:0 !important;
          padding-bottom:0 !important;
          left:200px;
          margin-left:20px;
          padding-left:0;
        }
        .flowValue,
        .pValue{
          font-size:9px;
        }
        .dFlow {
         left:-15.5%;
        }
        .oAngle {
          top:91% !important;
        }
        #outerImage {
          width: 39vw;
          left:15px !important;
        }
        #app {
            margin-left:20px;
            margin-right:20px;
        }
        .locator {
            display: block;
        }
    }
</style>
<style>
    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    .myTooltip {
        background-color: #fff;
        border: 1px solid #999;
        color: #000;
        font-family: "DINNextLTW05-Regular", Arial, sans-serif !important;
    }

    .tooltip-arrow {
        display: none !important;
        border-color: red;
    }
    .imageWrapper, #myDiagram {
      display:none;
    }
    @media print {
      #app {
        margin-top:0 !important;
      }
      html, body, .main {
        width: 100% !important;
        height: 100% !important;
        page-break-after: auto !important;
      }

      ._headline__title,
      #text,
      #contactteaser,
      ._topbutton{
        display:none;
      }
      #myDiagram{
        margin-top:0;
        padding-top:0;

      }
    }
    @page
    {
        size:  A4;
        margin: 0px;
        margin-top:12px;
        margin-bottom:12px;
    }
</style>